<template>
  <div class="col-12 col-md-5 affix-top p-0">
    <div class="btn-group-fab d-block d-md-none">
      <button
          @click="togglePreview"
          type="button"
          class="btn btn-main btn-secondary btn-lg toggle-preview-button"
          data-placement="right"
          title="Menu">
        <h7><i class="fas " :class="toggleButtonIcon"></i></h7>
      </button>
    </div>
    <div :class="{'affix-preview-mobile': showToggleButton }" class="panel panel-full-alt4">
      <div class="panel-heading">
        <div class="row">
          <div class="col-5 text-left">
            <span class="title">
              Pré-visualização
            </span>
          </div>
          <div class="col-5">
            <vue-slider
                ref="slider"
                v-model="zoom"
                tooltip="hover"
                tooltip-dir="bottom"
                :min="1"
                class="preview-zoom"
                :max="300"
                formatter='{value}%'>
            </vue-slider>
          </div>
          <div class="col-2 text-right">
            <button
                name="zoom-reset" type="button" @click="setInitialZoom()"
                class="btn btn-link btn-xs btn-reset" data-toggle="tooltip" data-placement="bottom" title=""
                data-original-title="Voltar ao Tamanho Original">
              <i class="fas fa-undo text-white"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="panel-body">
        <div id="preview" class="poster-preview" v-if="poster" v-html="poster"></div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import vueSlider from 'vue-slider-component';
import SelectorService from './services/selector_service.js';
import {Encoder} from '@nuintun/qrcode';

export default {
  components: {
    vueSlider,
  },
  props: {
    campaignDescription: {
      type: String,
      default: 'Dinâmica Comercial',
    },
    subDomain: {
      required: false,
    },

    justUpdateContent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      state: this.$store.state.selector,
      firstLoad: false,
      posterState: this.$store.state.poster,
      zoom: 100,
      userPreferences: $.parseJSON($('#user-preferences').val()),
      showToggleButton: false,
    };
  },
  watch: {
    percentage_app() {
      this.toHide();
      this.setPercentageApp();
    },
    price_app() {
      this.toHide();
      this.setPriceApp();
    },
    limit_app() {
      this.toHide();
      this.setLimitApp();
    },
    percentage_card() {
      this.toHide();
      this.setPercentageCard();
    },
    price_card() {
      this.toHide();
      this.setPriceCard();
    },
    limit_card() {
      this.toHide();
      this.setLimitCard();
    },
    parcel_number_card() {
      this.toHide();
      this.setParcelNumberCard();
    },
    parcel_price_card() {
      this.toHide();
      this.setParcelPriceCard();
    },
    minimum_app() {
      this.toHide();
      this.setMinimumApp();
    },
    base_value() {
      this.toHide();
      this.setBaseValue();
    },
    base_total_value() {
      this.toHide();
      this.setBaseTotalValue();
    },
    base_parcel_quantity() {
      this.toHide();
      this.setBaseParcelQuantity();
    },
    base_parcel_value() {
      this.toHide();
      this.setBaseParcelValue();
    },
    derived_code() {
      this.toHide();
      this.setDerivedCode();
    },
    ibm_code() {
      this.toHide();
      this.setIbmCode();
    },
    product_weight() {
      this.toHide();
      this.setProductWeight();
    },
    highlight_1() {
      this.toHide();
      this.setHighlight1();
    },
    highlight_2() {
      this.toHide();
      this.setHighlight2();
    },
    highlight_3() {
      this.toHide();
      this.setHighlight3();
    },
    highlight_4() {
      this.toHide();
      this.setHighlight4();
    },
    highlight_5() {
      this.toHide();
      this.setHighlight5();
    },
    highlight_6() {
      this.toHide();
      this.setHighlight6();
    },
    inputs() {
      this.toHide();
      this.setInputs();
    },
    productSelected: {
      handler(productSelected, oldProductSelected) {
        const newId = _.get(productSelected, 'id');
        const oldId = _.get(oldProductSelected, 'id');
        if ((newId && oldId) && (newId != oldId)) {
          $('[id^=image-]').attr('src', '');
          this.loadImages();
        }
      },
    },
    zoom(zoomValue) {
      const scale = zoomValue / 100;
      let $posterPreview = $('#preview');
      this.changeScale($posterPreview, scale);
    },
    poster() {
      this.$nextTick().then(() => {
        this.toHide();
        if (!this.firstLoad) {
          this.setInitialZoom();
        }
      });
    },
    theme() {
      if (!!this.theme) {
        this.$nextTick().then(() => {
          $('img[data-role=backgroundImage]').attr('src', '/ajax/template/theme/' + this.theme.id + '/image');
          this.poster = $('#preview').html();
          this.setInitialZoom();
          this.setAllValues();
        });
      }
    },
    template() {
      if (!!this.template) {
        this.$nextTick().then(() => {
          if (this.template.default_font)
            $('#preview *[style*=font-family]').css('font-family', '\"' + this.template.default_font.name + '\"');
          this.poster = $('#preview').html();
          this.setInitialZoom();
          this.$root.$emit('is-barcode', document.querySelector('#barcode'));
          this.setAllValues();
          this.startTextValues();
          if (this.isMagazine && this.image) {
            this.setImageFromApi(this.image);
          }
        })
            .then(() => this.loadImages())
            .then(() => this.loadTemplateColors())
            .then(() => this.loadFontsSize());
      }
    },
    with_down_payment_condition() {
      this.toHide();
    },
    cet_py() {
      this.toHide();
      this.setCetPy();
    },
    payment_type_text() {
      this.toHide();
      this.setPaymentTypeText();
    },
    has_interest() {
      this.toHide();
      this.setHasInterest();
    },
    cet() {
      this.toHide();
      this.setCet();
    },
    discount() {
      this.toHide();
      this.setDiscount();
    },
    discount_fastshop() {
      this.toHide();
      this.setDiscountFastshop();
    },
    discount_bundle() {
      this.toHide();
      this.setDiscountBundle();
    },
    legal_informations() {
      this.toHide();
      this.setLegalInformations();
    },
    main_description() {
      this.toHide();
      this.setMainDescription();
    },
    from_wholesale() {
      this.toHide();
      this.setFromWholesale();
    },
    from_large() {
      this.toHide();
      this.setFromLarge();
    },
    proportional_measure() {
      this.toHide();
      this.setProportionalMeasure();
      this.setProductProportionalValue();
      if (this.product_proportional_value && this.product_proportional_value.trim() !== '' &&
          this.proportional_measure && this.proportional_measure.trim() !== '' &&
          this.proportional_quantity &&
          !this.insertProductProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },
    proportional_quantity() {
      this.toHide();
      this.setProportionalQuantity();
      this.setProductProportionalValue();
      if (this.product_proportional_value && this.product_proportional_value.trim() !== '' &&
          this.proportional_measure && this.proportional_measure.trim() !== '' &&
          this.proportional_quantity &&
          !this.insertProductProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },
    product_proportional_value() {
      this.toHide();
      this.setProductProportionalValue();
      if (this.product_proportional_value && this.product_proportional_value.trim() !== '' &&
          this.proportional_measure && this.proportional_measure.trim() !== '' &&
          this.proportional_quantity &&
          !this.insertProductProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },
    main_description2() {
      this.toHide();
      this.setMainDescription2();
    },
    main_description3() {
      this.toHide();
      this.setMainDescription3();
    },
    minor_description() {
      this.toHide();
      this.setMinorDescription();
    },
    minor_description2() {
      this.toHide();
      this.setMinorDescription2();
    },
    minor_description3() {
      this.toHide();
      this.setMinorDescription3();
    },
    simple_description() {
      this.toHide();
      this.setSimpleDescription();
    },
    simple_description2() {
      this.toHide();
      this.setSimpleDescription2();
    },
    simple_description3() {
      this.toHide();
      this.setSimpleDescription3();
    },
    simple_description4() {
      this.toHide();
      this.setSimpleDescription4();
    },
    simple_description5() {
      this.toHide();
      this.setSimpleDescription5();
    },
    reoperated_product() {
      this.toHide();
      this.setReoperatedProduct();
    },
    product_other_sizes() {
      this.toHide();
      this.setProductOtherSizes();
    },
    product_other_colors() {
      this.toHide();
      this.setProductOtherColors();
    },
    product_comments() {
      this.toHide();
      this.setProductComments();
    },
    product_evaluation() {
      this.toHide();
      this.setProductEvaluation();
    },
    product_material() {
      this.toHide();
      this.setProductMaterial();
    },
    product_depth() {
      this.toHide();
      this.setProductDepth();
    },
    product_height() {
      this.toHide();
      this.setProductHeight();
    },
    product_width() {
      this.toHide();
      this.setProductWidth();
    },
    brand() {
      this.toHide();
      this.setBrand();
    },
    retail_packaging() {
      this.toHide();
      this.setRetailPackaging();
    },
    wholesale_packing() {
      this.toHide();
      this.setWholesalePacking();
    },
    big_packing() {
      this.toHide();
      this.setBigPacking();
    },
    validation() {
      this.toHide();
      this.setValidation();
    },
    retail_taxation() {
      this.toHide();
      this.setRetailTaxation();
    },
    wholesale_taxation() {
      this.toHide();
      this.setWholesaleTaxation();
    },
    big_taxation() {
      this.toHide();
      this.setBigTaxation();
    },
    light_taxation() {
      this.toHide();
      this.setLightTaxation();
    },
    retail_media() {
      this.toHide();
      this.setRetailMedia();
    },
    wholesale_media() {
      this.toHide();
      this.setWholesaleMedia();
    },
    big_media() {
      this.toHide();
      this.setBigMedia();
    },
    light_media() {
      this.toHide();
      this.setLightMedia();
    },
    big_price() {
      this.toHide();
      this.setBigPrice();
    },
    light_price() {
      this.toHide();
      this.setLightPrice();
    },
    light_quantity() {
      this.toHide();
      this.setLightQuantity();
    },
    free_text() {
      this.toHide();
      this.setFreeText();
    },
    free_text2() {
      this.toHide();
      this.setFreeText2();
    },
    free_text3() {
      this.toHide();
      this.setFreeText3();
    },
    exclusive_parcel() {
      this.toHide();
      this.setExclusiveParcel();
    },
    exclusive_parcel_2() {
      this.toHide();
      this.setExclusiveParcel2();
    },
    parcel() {
      this.toHide();
      this.setParcel();
    },
    parcel_separated_2() {
      this.toHide();
      this.setParcelSeparated2();
    },
    parcel_paid() {
      this.toHide();
      this.setParcelPaid();
    },
    parceled_interest() {
      this.toHide();
      this.setParceledInterest();
    },
    parceled_interest_2() {
      this.toHide();
      this.setParceledInterest2();
    },
    parceled() {
      this.toHide();
      this.setParceled();
    },
    condition() {
      this.toHide();
      this.setPaymentType();
    },
    product_code() {
      this.toHide();
      this.setProductCode();
    },
    promotion_description() {
      this.toHide();
      this.setPromotionDescription();
    },
    promotion_main_description() {
      this.toHide();
      this.setPromotionMainDescription();
    },
    promotion_minor_description() {
      this.toHide();
      this.setPromotionMinorDescription();
    },
    promotion_product() {
      this.toHide();
      this.setPromotionProduct();
    },
    promotion_unit() {
      this.toHide();
      this.setPromotionUnit();
    },
    promotion_unit2() {
      this.toHide();
      this.setPromotionUnit2();
    },
    promotional_product_value() {
      this.toHide();
      this.setPromotionalProductValue();
    },
    quantity() {
      this.toHide();
      this.setQuantity();
    },
    quantity_fractional() {
      this.toHide();
      this.setQuantityFractional();
    },
    quantity2() {
      this.toHide();
      this.setQuantity2();
    },
    quantity3() {
      this.toHide();
      this.setQuantity3();
    },
    quantity4() {
      this.toHide();
      this.setQuantity4();
    },
    quantity5() {
      this.toHide();
      this.setQuantity5();
    },
    rates_info() {
      this.toHide();
      this.setRatesInfo();
    },
    sales_unit_wholesale() {
      this.toHide();
      this.setSalesUnitWholeSale();
    },
    department() {
      this.toHide();
      this.setDepartment();
    },
    sales_unit() {
      this.toHide();
      this.setSalesUnit();
    },
    sales_unit2() {
      this.toHide();
      this.setSalesUnit2();
    },
    sales_unit3() {
      this.toHide();
      this.setSalesUnit3();
    },
    spare() {
      this.toHide();
      this.setSpare();
    },
    spared_percent() {
      this.toHide();
      this.setSparedPercent();
    },
    total_term() {
      this.toHide();
      this.setTotalTerm();
    },
    total_term_2() {
      this.toHide();
      this.setTotalTerm2();
    },
    valid_from() {
      this.setValidFrom();
      if (this.valid_from && this.valid_until && !this.insertExpirationDates) {
        this.$store.commit('poster/SET_INSERT_EXPIRATION_DATES', true);
      }
    },
    valid_until() {
      this.setValidUntil();
      if (this.valid_from && this.valid_until && !this.insertExpirationDates) {
        this.$store.commit('poster/SET_INSERT_EXPIRATION_DATES', true);
      }
    },
    proportional_value() {
      this.setProportionalValue();
      this.setUnitProportional();
      if (this.proportional_value && this.proportional_value.trim() !== '' &&
          this.unit_proportional && this.unit_proportional.trim() !== '' &&
          !this.insertProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },
    unit_proportional() {
      this.setUnitProportional();
      this.setProportionalValue();
      if (this.proportional_value && this.proportional_value.trim() !== '' &&
          this.unit_proportional && this.unit_proportional.trim() !== '' &&
          !this.insertProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },
    validate() {
      this.setValidate();
    },
    product_older() {
      this.setProductOlder();
    },
    free_value() {
      this.toHide();
      this.setFreeValue();
    },
    value_cash() {
      this.toHide();
      this.setValueCash();
    },
    value_cash2() {
      this.toHide();
      this.setValueCash2();
    },
    value_cash3() {
      this.toHide();
      this.setValueCash3();
    },
    value_bundle() {
      this.toHide();
      this.setValueBundle();
    },
    value_divided() {
      this.toHide();
      this.setValueDivided();
    },
    reduced_value() {
      this.toHide();
      this.setReducedValue();
    },
    value_old() {
      this.toHide();
      this.setValueOld();
    },
    value_old2() {
      this.toHide();
      this.setValueOld2();
    },
    value_old3() {
      this.toHide();
      this.setValueOld3();
    },
    custom_qr_code() {
      this.setImageCustomQrCode(this.insert_custom_qrcode);
    },
    qr_code() {
      this.setImageQrCode(this.insert_qrcode);
    },
    insert_custom_qrcode(payload) {
      this.setInsertCustomQrCode(payload);
    },
    insert_qrcode(payload) {
      this.setInsertQrCode(payload);
    },
    bar_code(payload) {
      this.createImageBarcode();
    },
    insert_barcode(payload) {
      this.setInsertBarcode(payload);
    },
    total_value() {
      this.toHide();
      this.setTotalValue();
    },
    unitary_value() {
      this.toHide();
      this.setUnitaryValue();
    },
    cashback_value() {
      this.toHide();
      this.setCashbackValue();
    },
    cashback_value_2() {
      this.toHide();
      this.setCashbackValue2();
    },
    value_in_cash() {
      this.toHide();
      this.setValueInCash();
    },
    exclusive_value_cash() {
      this.toHide();
      this.setExclusiveValueCash();
    },
    exclusive_value_cash_2() {
      this.toHide();
      this.setExclusiveValueCash2();
    },
    exclusive_value_in_cash() {
      this.toHide();
      this.setExclusiveValueInCash();
    },
    exclusive_value_in_cash_2() {
      this.toHide();
      this.setExclusiveValueInCash2();
    },
    value_plot_interest() {
      this.toHide();
      this.setValuePlotInterest();
    },
    value_plot_interest_2() {
      this.toHide();
      this.setValuePlotInterest2();
    },
    value_plot() {
      this.toHide();
      this.setValuePlot();
    },
    value_plot_separated() {
      this.toHide();
      this.setValuePlotSeparated();
    },
    value_plot_separated_2() {
      this.toHide();
      this.setValuePlotSeparated2();
    },
    exclusive_value_plot() {
      this.toHide();
      this.setExclusiveValuePlot();
    },
    exclusive_value_plot_2() {
      this.toHide();
      this.setExclusiveValuePlot2();
    },
    value_remaining() {
      this.toHide();
      this.setValueRemaing();
    },
    value_retail() {
      this.toHide();
      this.setValueRetail();
    },
    value_wholeretail() {
      this.toHide();
      this.setValueWholeretail();
    },
    value_wholeretail_2() {
      this.toHide();
      this.setValueWholeretail2();
    },
    value_wholeretail_3() {
      this.toHide();
      this.setValueWholeretail3();
    },
    value_wholeretail_4() {
      this.toHide();
      this.setValueWholeretail4();
    },
    value_wholeretail_5() {
      this.toHide();
      this.setValueWholeretail5();
    },
    value_sum() {
      this.toHide();
      this.setValueSum();
    },
    value_total_wholesale() {
      this.toHide();
      this.setValueTotalWholesale();
    },
    value_wholesale() {
      this.toHide();
      this.setValueWholesale();
    },
    value_wholesale_card() {
      this.toHide();
      this.setValueWholesaleCard();
    },
    value_cash_tag() {
      this.toHide();
      this.setValueCashTag(this.insert_value_cash_tag);
    },
    warranty() {
      this.toHide();
      this.setWarranty();
    },
    assembly() {
      this.toHide();
      this.setAssembly();
    },
    about_product() {
      this.toHide();
      this.setAboutProduct();
    },
    supported_weight() {
      this.toHide();
      this.setSupportedWeight();
    },
    insert_value_cash_tag(payload) {
      this.setInsertValueCashTag(payload);
    },
    insertExpirationDates() {
      this.hideDate();
    },
    insertProportionalValueInline() {
      this.hideProportionalValueInline();

      if (!this.insertProportionalValueInline) {
        this.$store.commit('poster/SET_PROPORTIONAL_VALUE', '');
        this.$store.commit('poster/SET_UNIT_PROPORTIONAL', '');
      }
    },
    insertProductProportionalValueInline() {
      this.hideProductProportionalValueInline();

      if (!this.insertProductProportionalValueInline) {
        this.$store.commit('poster/SET_PROPORTIONAL_MEASURE', '');
        this.$store.commit('poster/SET_PROPORTIONAL_QUANTITY', '');
        this.$store.commit('poster/SET_PRODUCT_PROPORTIONAL_VALUE', '');
      }
    },
    insertProductExpirationDates() {
      this.hideProductDate();
    },
    insertProductOlder() {
      this.hideProductOlder();
    },
    insert_offer_information() {
      this.hideOfferInformation();
    },
    insert_optional_free_text() {
      this.hideOptionalFreeText();
    },
    offer_information() {
      this.setOfferInformation();
    },
    optional_free_text() {
      this.setOptionalFreeText();
    },
    templateColors(colors) {
      colors.map((item) => {
        let component = $(`div[data-allowed-to-edit="${item.position}"]`);
        if (item.position.includes('form')) {
          component = component.children('div').children('svg');
        }
        component.css(item.color_attr, item.color);
      });
    },
    image(image) {
      this.setImageFromApi(image);
    },
  },
  computed: {
    toggleButtonText() {
      return (this.showToggleButton) ? 'Esconder' : 'Pré-visualizar';
    },
    toggleButtonIcon() {
      return (this.showToggleButton) ? 'fa-times' : 'fa-search';
    },
    isMagazine() {
      return this.subDomain === 'magazineluiza';
    },
    paperDescription() {
      return (this.isMagazine) ? 'Tamanho do cartaz' : 'Tamanho';
    },
    templateDescription() {
      return (this.isMagazine) ? 'a Campanha' : 'o Layout Coordenada';
    },
    productSelected() {
      return this.$store.getters['poster/getSelectedProduct'];
    },
    template() {
      return this.$store.getters['selector/getTemplate'];
    },
    templateImages: {
      get() {
        return this.$store.getters['selector/getTemplateImages'];
      },
      set(images) {
        this.$store.commit('selector/SET_IMAGES', images);
      },
    },
    templateColors: {
      get() {
        return this.$store.getters['selector/getTemplateColors'];
      },
      set(colors) {
        this.$store.commit('selector/SET_TEMPLATE_COLORS', colors);
      },
    },
    poster: {
      get() {
        if (typeof this.template != 'undefined') {
          return this.template.content;
        }
        if (typeof this.state.poster != 'undefined') {
          return this.$store.getters['poster/field']('content');
        }
      },
      set: _.debounce(function (content) {
        if (content) {
          this.$store.commit('poster/SET_CONTENT', content);
          if (!this.firstLoad) {
            this.$root.$emit('preview_ready');
            this.firstLoad = true;
            this.setInitialZoom();
          }
        }
      }, 200),
    },
    theme() {
      return this.state.theme;
    },
    aliases() {
      if (this.isNotUndefined(this.template)) {
        return this.template.fields.reduce((carry, field) => {
          carry[field.poster_field.field_id] = field.poster_field.aliases;
          return carry;
        }, []);
      }
      return [];
    },
    with_down_payment_condition() {
      return this.$store.getters['poster/getWithDownPaymentCondition'];
    },
    cet_py() {
      return this.$store.getters['poster/field']('cet_py');
    },
    cet() {
      return this.$store.getters['poster/field']('cet');
    },
    inputs() {
      return this.$store.getters['poster/field']('inputs');
    },
    unit_proportional() {
      return this.$store.getters['poster/field']('unit_proportional');
    },
    discount() {
      return this.$store.getters['poster/field']('discount');
    },
    discount_fastshop() {
      return this.$store.getters['poster/field']('discount_fastshop');
    },
    percentage_app() {
      return this.$store.getters['poster/field']('percentage_app');
    },
    price_app() {
      return this.$store.getters['poster/field']('price_app');
    },
    limit_app() {
      return this.$store.getters['poster/field']('limit_app');
    },
    percentage_card() {
      return this.$store.getters['poster/field']('percentage_card');
    },
    price_card() {
      return this.$store.getters['poster/field']('price_card');
    },
    limit_card() {
      return this.$store.getters['poster/field']('limit_card');
    },
    parcel_number_card() {
      return this.$store.getters['poster/field']('parcel_number_card');
    },
    parcel_price_card() {
      return this.$store.getters['poster/field']('parcel_price_card');
    },
    minimum_app() {
      return this.$store.getters['poster/field']('minimum_app');
    },
    discount_bundle() {
      return this.$store.getters['poster/field']('discount_bundle');
    },
    has_interest() {
      return this.$store.getters['poster/field']('has_interest');
    },
    image() {
      return this.$store.getters['poster/field']('image');
    },
    legal_informations() {
      return this.$store.getters['poster/field']('legal_informations');
    },
    main_description() {
      return this.$store.getters['poster/field']('main_description');
    },
    from_wholesale() {
      return this.$store.getters['poster/field']('from_wholesale');
    },
    from_large() {
      return this.$store.getters['poster/field']('from_large');
    },
    proportional_measure() {
      return this.$store.getters['poster/field']('proportional_measure');
    },
    proportional_quantity() {
      return this.$store.getters['poster/field']('proportional_quantity');
    },
    product_proportional_value() {
      return this.$store.getters['poster/field']('product_proportional_value');
    },
    ibm_code() {
      return this.$store.getters['poster/field']('ibm_code');
    },
    product_weight() {
      return this.$store.getters['poster/field']('product_weight');
    },
    highlight_1() {
      return this.$store.getters['poster/field']('highlight_1');
    },
    highlight_2() {
      return this.$store.getters['poster/field']('highlight_2');
    },
    highlight_3() {
      return this.$store.getters['poster/field']('highlight_3');
    },
    highlight_4() {
      return this.$store.getters['poster/field']('highlight_4');
    },
    highlight_5() {
      return this.$store.getters['poster/field']('highlight_5');
    },
    highlight_6() {
      return this.$store.getters['poster/field']('highlight_6');
    },
    main_description2() {
      return this.$store.getters['poster/field']('main_description2');
    },
    main_description3() {
      return this.$store.getters['poster/field']('main_description3');
    },
    minor_description() {
      return this.$store.getters['poster/field']('minor_description');
    },
    minor_description2() {
      return this.$store.getters['poster/field']('minor_description2');
    },
    minor_description3() {
      return this.$store.getters['poster/field']('minor_description3');
    },
    simple_description() {
      return this.$store.getters['poster/field']('simple_description');
    },
    simple_description2() {
      return this.$store.getters['poster/field']('simple_description2');
    },
    simple_description3() {
      return this.$store.getters['poster/field']('simple_description3');
    },
    simple_description4() {
      return this.$store.getters['poster/field']('simple_description4');
    },
    simple_description5() {
      return this.$store.getters['poster/field']('simple_description5');
    },
    reoperated_product() {
      return this.$store.getters['poster/field']('reoperated_product');
    },
    product_other_sizes() {
      return this.$store.getters['poster/field']('product_other_sizes');
    },
    product_other_colors() {
      return this.$store.getters['poster/field']('product_other_colors');
    },
    product_comments() {
      return this.$store.getters['poster/field']('product_comments');
    },
    product_evaluation() {
      return this.$store.getters['poster/field']('product_evaluation');
    },
    product_material() {
      return this.$store.getters['poster/field']('product_material');
    },
    product_height() {
      return this.$store.getters['poster/field']('product_height');
    },
    product_depth() {
      return this.$store.getters['poster/field']('product_depth');
    },
    product_width() {
      return this.$store.getters['poster/field']('product_width');
    },
    brand() {
      return this.$store.getters['poster/field']('brand');
    },
    retail_packaging() {
      return this.$store.getters['poster/field']('retail_packaging');
    },
    wholesale_packing() {
      return this.$store.getters['poster/field']('wholesale_packing');
    },
    big_packing() {
      return this.$store.getters['poster/field']('big_packing');
    },
    validation() {
      return this.$store.getters['poster/field']('validation');
    },
    retail_taxation() {
      return this.$store.getters['poster/field']('retail_taxation');
    },
    wholesale_taxation() {
      return this.$store.getters['poster/field']('wholesale_taxation');
    },
    big_taxation() {
      return this.$store.getters['poster/field']('big_taxation');
    },
    light_taxation() {
      return this.$store.getters['poster/field']('light_taxation');
    },
    retail_media() {
      return this.$store.getters['poster/field']('retail_media');
    },
    wholesale_media() {
      return this.$store.getters['poster/field']('wholesale_media');
    },
    big_media() {
      return this.$store.getters['poster/field']('big_media');
    },
    light_media() {
      return this.$store.getters['poster/field']('light_media');
    },
    big_price() {
      return this.$store.getters['poster/field']('big_price');
    },
    light_price() {
      return this.$store.getters['poster/field']('light_price');
    },
    light_quantity() {
      return this.$store.getters['poster/field']('light_quantity');
    },
    free_text() {
      return this.$store.getters['poster/field']('free_text');
    },
    free_text2() {
      return this.$store.getters['poster/field']('free_text2');
    },
    free_text3() {
      return this.$store.getters['poster/field']('free_text3');
    },
    exclusive_parcel() {
      return this.$store.getters['poster/field']('exclusive_parcel');
    },
    exclusive_parcel_2() {
      return this.$store.getters['poster/field']('exclusive_parcel_2');
    },
    parcel() {
      return this.$store.getters['poster/field']('parcel');
    },
    parcel_separated_2() {
      return this.$store.getters['poster/field']('parcel_separated_2');
    },
    parcel_paid() {
      return this.$store.getters['poster/field']('parcel_paid');
    },
    parceled_inline() {
      return this.$store.getters['poster/field']('parceled_inline');
    },
    parceled_interest_inline() {
      return this.$store.getters['poster/field']('parceled_interest_inline');
    },
    parceled_interest() {
      return this.$store.getters['poster/field']('parceled_interest');
    },
    parceled_interest_2() {
      return this.$store.getters['poster/field']('parceled_interest_2');
    },
    parceled() {
      return this.$store.getters['poster/field']('parceled');
    },
    condition() {
      return this.$store.getters['poster/field']('condition');
    },
    payment_type_text() {
      return this.$store.getters['poster/field']('payment_type');
    },
    payment_type: {
      set(payment_type) {
        this.$store.commit('poster/SET_PAYMENT_TYPE', payment_type);
      },
      get() {
        return this.$store.getters['poster/field']('payment_type');
      },
    },
    product_code() {
      return this.$store.getters['poster/field']('product_code');
    },
    promotion_description() {
      return this.$store.getters['poster/field']('promotion_description');
    },
    promotion_main_description() {
      return this.$store.getters['poster/field']('promotion_main_description');
    },
    promotion_minor_description() {
      return this.$store.getters['poster/field']('promotion_minor_description');
    },
    promotion_product() {
      return this.$store.getters['poster/field']('promotion_product');
    },
    promotion_unit() {
      return this.$store.getters['poster/field']('promotion_unit');
    },
    promotion_unit2() {
      return this.$store.getters['poster/field']('promotion_unit2');
    },
    promotional_product_value() {
      return this.$store.getters['poster/field']('promotional_product_value');
    },
    quantity() {
      return this.$store.getters['poster/field']('quantity');
    },
    quantity_fractional() {
      return this.$store.getters['poster/field']('quantity_fractional');
    },
    quantity2() {
      return this.$store.getters['poster/field']('quantity2');
    },
    quantity3() {
      return this.$store.getters['poster/field']('quantity3');
    },
    quantity4() {
      return this.$store.getters['poster/field']('quantity4');
    },
    quantity5() {
      return this.$store.getters['poster/field']('quantity5');
    },
    rates_info() {
      return this.$store.getters['poster/field']('rates_info');
    },
    sales_unit_wholesale() {
      return this.$store.getters['poster/field']('sales_unit_wholesale');
    },
    department() {
      return this.$store.getters['poster/field']('departament');
    },
    sales_unit() {
      return this.$store.getters['poster/field']('sales_unit');
    },
    sales_unit2() {
      return this.$store.getters['poster/field']('sales_unit2');
    },
    sales_unit3() {
      return this.$store.getters['poster/field']('sales_unit3');
    },
    spare_inline() {
      return this.$store.getters['poster/field']('spare_inline');
    },
    spare() {
      return this.$store.getters['poster/field']('spare');
    },
    spared_percent() {
      return this.$store.getters['poster/field']('spared_percent');
    },
    total_term() {
      return this.$store.getters['poster/field']('total_term');
    },
    total_term_2() {
      return this.$store.getters['poster/field']('total_term_2');
    },
    valid_date_inline() {
      return this.$store.getters['poster/field']('valid_date_inline');
    },
    proportional_value_inline() {
      return this.$store.getters['poster/field']('proportional_value_inline');
    },
    valid_from() {
      return this.$store.getters['poster/field']('valid_from');
    },
    valid_until() {
      return this.$store.getters['poster/field']('valid_until');
    },
    validate() {
      return this.$store.getters['poster/field']('validate');
    },
    product_older() {
      return this.$store.getters['poster/field']('product_older');
    },
    value_cash_inline() {
      return this.$store.getters['poster/field']('value_cash_inline');
    },
    value_cash() {
      return this.$store.getters['poster/field']('value_cash');
    },
    free_value() {
      return this.$store.getters['poster/field']('free_value');
    },
    value_cash2() {
      return this.$store.getters['poster/field']('value_cash2');
    },
    value_cash3() {
      return this.$store.getters['poster/field']('value_cash3');
    },
    value_bundle() {
      return this.$store.getters['poster/field']('value_bundle');
    },
    value_divided() {
      return this.$store.getters['poster/field']('value_divided');
    },
    reduced_value() {
      return this.$store.getters['poster/field']('reduced_value');
    },
    value_old_inline() {
      return this.$store.getters['poster/field']('value_old_inline');
    },
    value_old() {
      return this.$store.getters['poster/field']('value_old');
    },
    value_old2() {
      return this.$store.getters['poster/field']('value_old2');
    },
    value_old3() {
      return this.$store.getters['poster/field']('value_old3');
    },
    custom_qr_code() {
      return this.$store.getters['poster/field']('custom_qr_code');
    },
    qr_code() {
      return this.$store.getters['poster/field']('qr_code');
    },
    insert_custom_qrcode() {
      return this.$store.getters['poster/field']('insert_custom_qrcode');
    },
    insert_qrcode() {
      return this.$store.getters['poster/field']('insert_qrcode');
    },
    bar_code() {
      return this.$store.getters['poster/field']('bar_code');
    },
    insert_barcode() {
      return this.$store.getters['poster/field']('insert_barcode');
    },
    optional_free_text() {
      return this.$store.getters['poster/field']('optional_free_text');
    },
    insert_optional_free_text() {
      return this.$store.getters['poster/field']('insert_optional_free_text');
    },
    total_value() {
      return this.$store.getters['poster/field']('total_value');
    },
    unitary_value() {
      return this.$store.getters['poster/field']('unitary_value');
    },
    cashback_value() {
      return this.$store.getters['poster/field']('cashback_value');
    },
    cashback_value_2() {
      return this.$store.getters['poster/field']('cashback_value_2');
    },
    value_in_cash() {
      return this.$store.getters['poster/field']('value_in_cash');
    },
    exclusive_value_in_cash() {
      return this.$store.getters['poster/field']('exclusive_value_in_cash');
    },
    exclusive_value_in_cash_2() {
      return this.$store.getters['poster/field']('exclusive_value_in_cash_2');
    },
    exclusive_value_cash() {
      return this.$store.getters['poster/field']('exclusive_value_cash');
    },
    exclusive_value_cash_2() {
      return this.$store.getters['poster/field']('exclusive_value_cash_2');
    },
    value_plot_interest() {
      return this.$store.getters['poster/field']('value_plot_interest');
    },
    value_plot_interest_2() {
      return this.$store.getters['poster/field']('value_plot_interest_2');
    },
    value_plot() {
      return this.$store.getters['poster/field']('value_plot');
    },
    value_plot_separated() {
      return this.$store.getters['poster/field']('value_plot_separated');
    },
    value_plot_separated_2() {
      return this.$store.getters['poster/field']('value_plot_separated_2');
    },
    exclusive_value_plot() {
      return this.$store.getters['poster/field']('exclusive_value_plot');
    },
    exclusive_value_plot_2() {
      return this.$store.getters['poster/field']('exclusive_value_plot_2');
    },
    value_remaining() {
      return this.$store.getters['poster/field']('value_remaining');
    },
    value_retail() {
      return this.$store.getters['poster/field']('value_retail');
    },
    value_wholeretail() {
      return this.$store.getters['poster/field']('value_wholeretail');
    },
    value_wholeretail_2() {
      return this.$store.getters['poster/field']('value_wholeretail_2');
    },
    value_wholeretail_3() {
      return this.$store.getters['poster/field']('value_wholeretail_3');
    },
    value_wholeretail_4() {
      return this.$store.getters['poster/field']('value_wholeretail_4');
    },
    value_wholeretail_5() {
      return this.$store.getters['poster/field']('value_wholeretail_5');
    },
    proportional_value() {
      return this.$store.getters['poster/field']('proportional_value');
    },
    value_sum() {
      return this.$store.getters['poster/field']('value_sum');
    },
    value_total_wholesale() {
      return this.$store.getters['poster/field']('value_total_wholesale');
    },
    value_wholesale() {
      return this.$store.getters['poster/field']('value_wholesale');
    },
    value_wholesale_card() {
      return this.$store.getters['poster/field']('value_wholesale_card');
    },
    value_cash_tag() {
      return this.$store.getters['poster/field']('value_cash_tag');
    },
    insert_value_cash_tag() {
      return this.$store.getters['poster/field']('insert_value_cash_tag');
    },
    insertExpirationDates() {
      return this.$store.getters['poster/getInsertExpirationDates'];
    },
    insertProportionalValueInline() {
      return this.$store.getters['poster/getInsertProportionalValueInline'];
    },
    insertProductProportionalValueInline() {
      return this.$store.getters['poster/getInsertProductProportionalValueInline'];
    },
    insertProductExpirationDates() {
      return this.$store.getters['poster/getInsertProductExpirationDates'];
    },
    insertProductOlder() {
      return this.$store.getters['poster/getInsertProductOlder'];
    },
    base_value() {
      return this.$store.getters['poster/field']('base_value');
    },
    base_total_value() {
      return this.$store.getters['poster/field']('base_total_value');
    },
    base_parcel_quantity() {
      return this.$store.getters['poster/field']('base_parcel_quantity');
    },
    derived_code() {
      return this.$store.getters['poster/field']('derived_code');
    },
    base_parcel_value() {
      return this.$store.getters['poster/field']('base_parcel_value');
    },
    warranty() {
      return this.$store.getters['poster/field']('warranty');
    },
    assembly() {
      return this.$store.getters['poster/field']('assembly');
    },
    about_product() {
      return this.$store.getters['poster/field']('about_product');
    },
    supported_weight() {
      return this.$store.getters['poster/field']('supported_weight');
    },
    offer_information() {
      return this.$store.getters['poster/field']('offer_information');
    },
    insert_offer_information() {
      return this.$store.getters['poster/field']('insert_offer_information');
    }
  },
  created() {
    this.$root.$on('loadImagesAfterClearFields', () => this.loadImages());
    this.$root.$on('loadTemplateContentInStore', this.loadTemplateContentInStore);
    this.$root.$on('handleCustomQRCode', (insertQrCode) => {
      this.$nextTick().then(() => this.setImageCustomQrCode(insertQrCode))
    });
  },
  methods: {
    setBaseValue() {
      let value = this.$store.getters['poster/field']('base_value');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'base_value');
      }
    },
    setBaseTotalValue() {
      let value = this.$store.getters['poster/field']('base_total_value');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'base_total_value');
      }
    },
    setBaseParcelQuantity() {
      if (typeof this.$store.getters['poster/field']('base_parcel_quantity') != undefined) {
        this.preview('base_parcel_quantity', 'integer', this.$store.getters['poster/field']('base_parcel_quantity'));
        this.previewMarked('base_parcel_quantity', this.$store.getters['poster/field']('base_parcel_quantity'));
      }
    },
    setBaseParcelValue() {
      let value = this.$store.getters['poster/field']('base_parcel_value');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'base_parcel_value');
      }
    },
    setDerivedCode() {
      if (typeof this.$store.getters['poster/field']('derived_code') != undefined) {
        this.preview('derived_code', 'integer', this.$store.getters['poster/field']('derived_code'));
        this.previewMarked('derived_code', this.$store.getters['poster/field']('derived_code'));
      }
    },

    setWarranty() {
      if (typeof this.$store.getters['poster/field']('warranty') != undefined) {
        this.preview('warranty', 'text', this.$store.getters['poster/field']('warranty'));
        this.previewMarked('warranty', this.$store.getters['poster/field']('warranty'));
      }
    },

    setAssembly() {
      if (typeof this.$store.getters['poster/field']('assembly') != undefined) {
        this.preview('assembly', 'text', this.$store.getters['poster/field']('assembly'));
        this.previewMarked('assembly', this.$store.getters['poster/field']('assembly'));
      }
    },
    setAboutProduct() {
      if (typeof this.$store.getters['poster/field']('about_product') != undefined) {
        let aboutProduct = this.$store.getters['poster/field']('about_product');
        if (aboutProduct)
          aboutProduct = aboutProduct.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('about_product', 'text', aboutProduct);
        this.previewMarked('about_product', aboutProduct);
      }
    },
    setSupportedWeight() {
      if (typeof this.$store.getters['poster/field']('supported_weight') != undefined) {
        this.preview('supported_weight', 'text', this.$store.getters['poster/field']('supported_weight'));
        this.previewMarked('supported_weight', this.$store.getters['poster/field']('supported_weight'));
      }
    },
    setOfferInformation() {
      if (typeof this.$store.getters['poster/field']('offer_information') != undefined) {
        this.preview('offer_information', 'text', this.$store.getters['poster/field']('offer_information'));
        this.previewMarked('offer_information', this.$store.getters['poster/field']('offer_information'));
      }
    },
    setOptionalFreeText() {
      if (typeof this.$store.getters['poster/field']('optional_free_text') != undefined) {
        let text = this.$store.getters['poster/field']('optional_free_text');
        if (text) {
          text = text.replace(/[\n|\n\r]/g, '<br \>');
        }
        this.preview('optional_free_text', 'desciption', text);
        this.previewMarked('optional_free_text', text);
      }
    },
    setIbmCode() {
      if (typeof this.$store.getters['poster/field']('ibm_code') != undefined) {
        let ibm_code = this.$store.getters['poster/field']('ibm_code');
        if (ibm_code)
          ibm_code = ibm_code.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('ibm_code', 'desciption', ibm_code);
        this.previewMarked('ibm_code', ibm_code);
      }
    },
    setProductWeight() {
      if (typeof this.$store.getters['poster/field']('product_weight') != undefined) {
        let product_weight = this.$store.getters['poster/field']('product_weight');
        this.preview('product_weight', 'desciption', product_weight);
        this.previewMarked('product_weight', product_weight);
      }
    },
    setHighlight1() {
      if (typeof this.$store.getters['poster/field']('highlight_1') != undefined) {
        let highlight_1 = this.$store.getters['poster/field']('highlight_1');
        if (highlight_1)
          highlight_1 = highlight_1.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('highlight_1', 'desciption', highlight_1);
        this.previewMarked('highlight_1', highlight_1);
      }
    },
    setHighlight2() {
      if (typeof this.$store.getters['poster/field']('highlight_2') != undefined) {
        let highlight_2 = this.$store.getters['poster/field']('highlight_2');
        if (highlight_2)
          highlight_2 = highlight_2.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('highlight_2', 'desciption', highlight_2);
        this.previewMarked('highlight_2', highlight_2);
      }
    },
    setHighlight3() {
      if (typeof this.$store.getters['poster/field']('highlight_3') != undefined) {
        let highlight_3 = this.$store.getters['poster/field']('highlight_3');
        if (highlight_3)
          highlight_3 = highlight_3.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('highlight_3', 'desciption', highlight_3);
        this.previewMarked('highlight_3', highlight_3);
      }
    },
    setHighlight4() {
      if (typeof this.$store.getters['poster/field']('highlight_4') != undefined) {
        let highlight_4 = this.$store.getters['poster/field']('highlight_4');
        if (highlight_4)
          highlight_4 = highlight_4.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('highlight_4', 'desciption', highlight_4);
        this.previewMarked('highlight_4', highlight_4);
      }
    },
    setHighlight5() {
      if (typeof this.$store.getters['poster/field']('highlight_5') != undefined) {
        let highlight_5 = this.$store.getters['poster/field']('highlight_5');
        if (highlight_5)
          highlight_5 = highlight_5.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('highlight_5', 'desciption', highlight_5);
        this.previewMarked('highlight_5', highlight_5);
      }
    },
    setHighlight6() {
      if (typeof this.$store.getters['poster/field']('highlight_6') != undefined) {
        let highlight_6 = this.$store.getters['poster/field']('highlight_6');
        if (highlight_6)
          highlight_6 = highlight_6.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('highlight_6', 'desciption', highlight_6);
        this.previewMarked('highlight_6', highlight_6);
      }
    },
    setUnitProportional() {
      if (typeof this.$store.getters['poster/field']('unit_proportional') != undefined) {
        let freeText = this.$store.getters['poster/field']('unit_proportional');
        if (freeText)
          freeText = freeText.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('unit_proportional', 'desciption', freeText);
        this.previewMarked('unit_proportional', freeText);
      }

      if (typeof this.$store.getters['poster/field']('unit_proportional') != undefined &&
          typeof this.$store.getters['poster/field']('proportional_value') != undefined) {
        let unit_proportional = this.$store.getters['poster/field']('unit_proportional');
        if (!unit_proportional || unit_proportional.trim() === '') {
          unit_proportional = ' ';
        }

        let element = $('div[data-role=proportional_value_inline] .component-content span.text');
        let html = element.html();

        if (html != undefined) {
          if (html.includes('data-unit-marker')) {
            let markerMatch = html.match(/(<span[^>]*data-unit-marker[^>]*data-after="([^"]*)"[^>]*>.*?<\/span>)/i);
            if (markerMatch) {
              let marker = markerMatch[1];
              let afterText = markerMatch[2];
              let newHtml = html.replace(/(<span[^>]*data-unit-marker[^>]*>.*?<\/span>)[^<]*/, marker + unit_proportional + afterText);
              this.preview('proportional_value_inline', 'text', newHtml);
            } else {
              let match = html.match(/(<span[^>]*data-unit-marker[^>]*>.*?<\/span>)([^<]*)/i);
              if (match) {
                let marker = match[1];
                let afterText = match[2];
                let newMarker = marker.replace('<span', '<span data-after="' + afterText + '"');
                let newHtml = html.replace(/(<span[^>]*data-unit-marker[^>]*>.*?<\/span>)[^<]*/, newMarker + unit_proportional + afterText);
                this.preview('proportional_value_inline', 'text', newHtml);
              }
            }
          } else {
            let match = html.match(/(.*?)(Unidade\s+de\s+venda\s+proporcional)(.*)/gi);
            if (match) {
              let fullMatch = match[0];
              let parts = fullMatch.match(/(.*?)(Unidade\s+de\s+venda\s+proporcional)(.*)/i);
              if (parts) {
                let before = parts[1];
                let after = parts[3];
                let newHtml = before + '<span data-unit-marker data-after="' + after + '" style="display:none;">Unidade de venda proporcional</span>' + unit_proportional + after;
                this.preview('proportional_value_inline', 'text', newHtml);
              }
            }
          }
        }
      }
    },
    checkAndMarkProportionalValueInline() {
      let proportionalValue = this.$store.getters['poster/field']('proportional_value');
      let unitProportional = this.$store.getters['poster/field']('unit_proportional');

      if (proportionalValue && proportionalValue.trim() !== '' &&
          unitProportional && unitProportional.trim() !== '' &&
          !this.insertProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },

    checkAndMarkProductProportionalValueInline() {
      let productProportionalValue = this.$store.getters['poster/field']('product_proportional_value');
      let proportionalMeasure = this.$store.getters['poster/field']('proportional_measure');
      let proportionalQuantity = this.$store.getters['poster/field']('proportional_quantity');

      if (productProportionalValue && productProportionalValue.trim() !== '' &&
          proportionalMeasure && proportionalMeasure.trim() !== '' &&
          proportionalQuantity && proportionalQuantity.trim() !== '' &&
          !this.insertProductProportionalValueInline) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_PROPORTIONAL_VALUE_INLINE', true);
      }
    },
    setInputs() {
      if (typeof this.$store.getters['poster/field']('inputs') != undefined) {
        this.preview('inputs', 'integer', this.$store.getters['poster/field']('inputs'));
        this.previewMarked('inputs', this.$store.getters['poster/field']('inputs'));
      }
    },
    togglePreview() {
      this.showToggleButton = !this.showToggleButton;
      $('#posterFiller').toggleClass('bottom-14');
    },
    startTextValues() {
      if (!this.posterState.product_id) {
        this.posterState.fields.unit_proportional = $('[data-role="unit_proportional"]').find('span').html();
        this.posterState.fields.free_text = $('[data-role="free_text"]').find('span').html();
        this.posterState.fields.free_text2 = $('[data-role="free_text2"]').find('span').html();
        this.posterState.fields.free_text3 = $('[data-role="free_text3"]').find('span').html();
        this.posterState.fields.promotion_description = $('[data-role="promotion_description"]').find('span').html();
        this.posterState.fields.offer_information = $('[data-role="offer_information"]').find('span').html();
        this.posterState.fields.sales_unit_wholesale = $('[data-role="sales_unit_wholesale"]').find('span').html();
        this.posterState.fields.promotion_unit = $('[data-role="promotion_unit"]').find('span').html();
        this.posterState.fields.promotion_unit2 = $('[data-role="promotion_unit2"]').find('span').html();
      }
    },
    hideDate() {
      $('[data-role=valid_date_inline], [data-role=valid_from], [data-role=valid_until]').toggle(this.insertExpirationDates);
    },
    hideProportionalValueInline() {
      $('[data-role=proportional_value_inline], [data-role=proportional_value], [data-role=unit_proportional]').toggle(this.insertProportionalValueInline);
    },
    hideProductProportionalValueInline() {
      $('[data-role=product_proportional_value_inline], [data-role=proportional_measure], [data-role=proportional_quantity], [data-role=product_proportional_value]').toggle(this.insertProductProportionalValueInline);
    },
    hideOfferInformation() {
      $('[data-role=offer_information], [data-role=marked-text-component]:has(div span alias[value=INFORMATIVO_OFERTA])').toggle(this.insert_offer_information);
    },
    hideOptionalFreeText() {
      $('[data-role=optional_free_text], [data-role=marked-text-component]:has(div span alias[value=TXT_LIVRE_OPC]), [data-role=marked-text-component]:has(div span alias[value=FTXT_OPC])').toggle(this.insert_optional_free_text);
    },
    hideProductDate() {
      $('[data-role=validate], [data-role=marked-text-component]:has(div span alias[value=VALIDADE]), [data-role=marked-text-component]:has(div span alias[value=VLD_UNICA])').toggle(this.insertProductExpirationDates);
    },
    hideProductOlder() {
      $('[data-role=product_older], .marked-text-component:has(div span alias[value=PRODUTO_18]), .marked-text-component:has(div span alias[value=PRD_18])').toggle(this.insertProductOlder);
    },
    toHide: _.debounce(function () {
      let meta_datas = $('#meta-data').children();
      for (let index = 0; index < meta_datas.length; index++) {
        let shouldShow = false;
        const element = $(meta_datas[index]);
        const metaId = element.attr('data-id');
        const condition = 'this.' + element.attr('data-trigger');
        const valuesToCompare = condition.match(/'(.+?)'/);
        const multiConditions = valuesToCompare[1].split('|');
        if (multiConditions.length) {
          shouldShow = !!multiConditions.find((value) => {
            const vm = this;
            const newCondition = 'vm.' + element.attr('data-trigger').replace(/'(.+?)'/, `'${value}'`);
            return newCondition && eval(newCondition);
          });
        } else {
          shouldShow = (condition && eval(condition));
        }

        $('div[data-id=' + metaId + ']').toggle(!shouldShow);
      }
    }, 300),
    setInitialZoom() {
      const vm = this;
      const $image = $('img[data-role=backgroundImage]');
      const imgWidth = $image.width();
      const imgHeight = $image.height();
      const divWidth = $image.closest('.panel-body').width();
      const divHeight = ($(window).width() > 200) ? $image.closest('.panel-body').height() : $(window).height() * 0.24;
      const scale = (imgWidth >= imgHeight) ? divWidth / imgWidth : divHeight / imgHeight;
      vm.zoom = (scale * 100).toFixed(0);
      $('[role="tooltip"]').hide();
    },
    setAllValues() {
      this.setIbmCode();
      this.setProductWeight();
      this.setHighlight1();
      this.setHighlight2();
      this.setHighlight3();
      this.setHighlight4();
      this.setHighlight5();
      this.setHighlight6();
      this.setCet();
      this.setCetPy();
      this.setHasInterest();
      this.setParceled();
      this.setDiscount();
      this.setDiscountFastshop();
      this.setDiscountBundle();
      this.setFreeValue();
      this.setValueCash();
      this.setValueCash2();
      this.setValueCash3();
      this.setValueBundle();
      this.setParceledInterest();
      this.setParceledInterest2();
      this.setLegalInformations();
      this.setMainDescription();
      this.setFromWholesale();
      this.setFromLarge();
      this.setMainDescription2();
      this.setMainDescription3();
      this.setMinorDescription();
      this.setMinorDescription2();
      this.setMinorDescription3();
      this.setParcel();
      this.setParcelSeparated2();
      this.setExclusiveParcel();
      this.setPaymentType();
      this.setProductCode();
      this.setParcelPaid();
      this.setPromotionDescription();
      this.setPromotionMainDescription();
      this.setPromotionMinorDescription();
      this.setPromotionProduct();
      this.setDepartment();
      this.setSalesUnit();
      this.setSalesUnit2();
      this.setSalesUnit3();
      this.setPromotionUnit();
      this.setPromotionUnit2();
      this.setQuantity();
      this.setQuantityFractional();
      this.setQuantity2();
      this.setQuantity3();
      this.setQuantity4();
      this.setQuantity5();
      this.setRatesInfo();
      this.setSalesUnitWholeSale();
      this.setPromotionalProductValue();
      this.setSpare();
      this.setSparedPercent();
      this.setTotalTerm();
      this.setTotalTerm2();
      this.setValueDivided();
      this.setValueSum();
      this.setUnitaryValue();
      this.setReducedValue();
      this.setValueOld();
      this.setValueOld2();
      this.setValueOld3();
      this.setInsertQrCode();
      this.setInsertBarcode(this.insert_barcode);
      this.setValuePlot();
      this.setValuePlotSeparated();
      this.setValuePlotSeparated2();
      this.setExclusiveValuePlot();
      this.setValuePlotInterest();
      this.setValuePlotInterest2();
      this.setValueRemaing();
      this.setValueRetail();
      this.setValueWholeretail();
      this.setValueWholeretail2();
      this.setValueWholeretail3();
      this.setValueWholeretail4();
      this.setValueWholeretail5();
      this.setProportionalValue();
      this.setUnitProportional();
      this.checkAndMarkProportionalValueInline();
      this.setProductProportionalValue();
      this.checkAndMarkProductProportionalValueInline();
      this.setValueTotalWholesale();
      this.setValueWholesale();
      this.setValidUntil();
      this.setValidate();
      this.setProductOlder();
      this.setValidFrom();
      this.setValueInCash();
      this.setExclusiveValueInCash();
      this.setExclusiveValueCash();
      this.setCashbackValue();
      this.setCashbackValue2();
      this.setImageCustomQrCode(this.insert_custom_qrcode);
      this.setImageQrCode(this.insert_qrcode);
      this.createImageBarcode();
      this.setProductComments();
      this.setProductEvaluation();
      this.setProductMaterial();
      this.setProductDepth();
      this.setProductHeight();
      this.setProductWidth();
      this.setProductOtherSizes();
      this.setProductOtherColors();
      this.setBrand();
      this.setRetailPackaging();
      this.setWholesalePacking();
      this.setBigPacking();
      this.setValidation();
      this.setRetailTaxation();
      this.setWholesaleTaxation();
      this.setBigTaxation();
      this.setLightTaxation();
      this.setRetailMedia();
      this.setWholesaleMedia();
      this.setBigMedia();
      this.setLightMedia();
      this.setBigPrice();
      this.setLightPrice();
      this.setLightQuantity();
      this.setInputs();
      this.setUnitProportional();
      this.setValueWholesaleCard();
      this.setValueCashTag(this.insert_value_cash_tag);
      this.setProportionalMeasure();
      this.setProportionalQuantity();
      this.setProductProportionalValue();
      this.setBaseValue();
      this.setBaseTotalValue();
      this.setBaseParcelQuantity();
      this.setBaseParcelValue();
      this.setDerivedCode();
      this.setWarranty();
      this.setAssembly();
      this.setAboutProduct();
      this.setSupportedWeight();
      this.setOfferInformation();
      this.setOptionalFreeText();
      this.setPercentageApp();
      this.setPriceApp();
      this.setLimitApp();
      this.setPercentageCard();
      this.setPriceCard();
      this.setLimitCard();
      this.setParcelNumberCard();
      this.setParcelPriceCard();
      this.hideOfferInformation();
      this.hideOptionalFreeText();
    },
    setCetPy() {
      if (typeof this.$store.getters['poster/field']('cet_py') != undefined) {
        let value = this.$store.getters['poster/field']('cet_py');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('cet_py', 'integer', value);
        this.previewMarked('cet_py', value);
      }
    },
    setHasInterest() {
      if (typeof this.$store.getters['poster/field']('has_interest') != undefined) {
        let value = this.$store.getters['poster/field']('has_interest');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('has_interest', 'integer', value);
        this.previewMarked('has_interest', value);
      }
    },
    setCet() {
      if (typeof this.$store.getters['poster/field']('cet') != undefined) {
        let value = this.$store.getters['poster/field']('cet');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('cet', 'integer', value);
        this.previewMarked('cet', value);
      }
    },
    setDiscount() {
      if (typeof this.$store.getters['poster/field']('discount') != undefined) {
        let value = this.$store.getters['poster/field']('discount');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('discount', 'integer', value);
        this.previewMarked('discount', value);
      }
    },
    setDiscountFastshop() {
      if (typeof this.$store.getters['poster/field']('discount_fastshop') != undefined) {
        let value = this.$store.getters['poster/field']('discount_fastshop');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('discount_fastshop', 'integer', value);
        this.previewMarked('discount_fastshop', value);
      }
    },
    setDiscountBundle() {
      if (typeof this.$store.getters['poster/field']('discount_bundle') != undefined) {
        let value = this.$store.getters['poster/field']('discount_bundle');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('discount_bundle', 'integer', value);
        this.previewMarked('discount_bundle', value);
      }
    },
    setLegalInformations() {
      if (typeof this.$store.getters['poster/field']('legal_informations') != undefined) {
        this.preview('legal_informations', 'text', this.$store.getters['poster/field']('legal_informations'));
        this.previewMarked('legal_informations', this.$store.getters['poster/field']('legal_informations'));
      }
    },
    setFreeValue() {
      let value = this.$store.getters['poster/field']('free_value');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'free_value');
      }
    },
    setValueCash() {
      let value = this.$store.getters['poster/field']('value_cash');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'value_cash');
      }
    },
    setValueCash2() {
      let value = this.$store.getters['poster/field']('value_cash2');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'value_cash2');
      }
    },
    setValueCash3() {
      let value = this.$store.getters['poster/field']('value_cash3');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'value_cash3');
      }
    },
    setValueBundle() {
      let value = this.$store.getters['poster/field']('value_bundle');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'value_bundle');
      }
    },
    setValueDivided() {
      if (typeof this.$store.getters['poster/field']('value_divided') != undefined) {
        let value = this.$store.getters['poster/field']('value_divided');
        this.setValueOnPreview(value, 'value_divided');
      }
    },
    setTotalValue() {
      if (!!this.$store.getters['poster/field']('total_value')) {
        let value = this.$store.getters['poster/field']('total_value');
        this.setValueOnPreview(value, 'total_value');
      }
    },
    setUnitaryValue() {
      if (!!this.$store.getters['poster/field']('unitary_value')) {
        let value = this.$store.getters['poster/field']('unitary_value');
        this.setValueOnPreview(value, 'unitary_value');
      }
    },
    setCashbackValue() {
      if (!!this.$store.getters['poster/field']('cashback_value')) {
        let value = this.$store.getters['poster/field']('cashback_value');
        this.setValueOnPreview(value, 'cashback_value');
      }
    },
    setCashbackValue2() {
      if (!!this.$store.getters['poster/field']('cashback_value_2')) {
        let value = this.$store.getters['poster/field']('cashback_value_2');
        this.setValueOnPreview(value, 'cashback_value_2');
      }
    },
    setValueInCash() {
      if (!!this.$store.getters['poster/field']('value_in_cash')) {
        let value = this.$store.getters['poster/field']('value_in_cash');
        this.setValueOnPreview(value, 'value_in_cash');
      }
    },
    setExclusiveValueInCash() {
      if (!!this.$store.getters['poster/field']('exclusive_value_in_cash')) {
        let value = this.$store.getters['poster/field']('exclusive_value_in_cash');
        this.setValueOnPreview(value, 'exclusive_value_in_cash');
      }
    },
    setExclusiveValueInCash2() {
      if (!!this.$store.getters['poster/field']('exclusive_value_in_cash_2')) {
        let value = this.$store.getters['poster/field']('exclusive_value_in_cash_2');
        this.setValueOnPreview(value, 'exclusive_value_in_cash_2');
      }
    },
    setExclusiveValueCash() {
      if (!!this.$store.getters['poster/field']('exclusive_value_cash')) {
        let value = this.$store.getters['poster/field']('exclusive_value_cash');
        this.setValueOnPreview(value, 'exclusive_value_cash');
      }
    },
    setExclusiveValueCash2() {
      if (!!this.$store.getters['poster/field']('exclusive_value_cash_2')) {
        let value = this.$store.getters['poster/field']('exclusive_value_cash_2');
        this.setValueOnPreview(value, 'exclusive_value_cash_2');
      }
    },
    setReducedValue() {
      if (typeof this.$store.getters['poster/field']('reduced_value') != undefined) {
        let value = this.$store.getters['poster/field']('reduced_value');
        this.setValueOnPreview(value, 'reduced_value');
      }
    },
    setValueOld() {
      if (typeof this.$store.getters['poster/field']('value_old') != undefined) {
        let value = this.$store.getters['poster/field']('value_old');
        this.setValueOnPreview(value, 'value_old');
      }
    },
    setValueOld2() {
      if (typeof this.$store.getters['poster/field']('value_old2') != undefined) {
        let value = this.$store.getters['poster/field']('value_old2');
        this.setValueOnPreview(value, 'value_old2');
      }
    },
    setValueOld3() {
      if (typeof this.$store.getters['poster/field']('value_old3') != undefined) {
        let value = this.$store.getters['poster/field']('value_old3');
        this.setValueOnPreview(value, 'value_old3');
      }
    },
    setInsertQrCode() {
      if (typeof this.$store.getters['poster/field']('insert_qrcode') != undefined) {
        this.setImageQrCode(this.$store.getters['poster/field']('insert_qrcode'));
      }
    },
    setInsertCustomQrCode() {
      if (typeof this.$store.getters['poster/field']('insert_custom_qrcode') != undefined) {
        this.setImageCustomQrCode(this.$store.getters['poster/field']('insert_custom_qrcode'));
      }
    },
    setInsertBarcode() {
      this.setImageBarcode(this.$store.getters['poster/field']('insert_barcode'));
    },
    setValuePlotInterest() {
      if (typeof this.$store.getters['poster/field']('value_plot_interest') != undefined) {
        let value = this.$store.getters['poster/field']('value_plot_interest');
        this.setValueOnPreview(value, 'value_plot_interest');
      }
    },
    setValuePlotInterest2() {
      if (typeof this.$store.getters['poster/field']('value_plot_interest_2') != undefined) {
        let value = this.$store.getters['poster/field']('value_plot_interest_2');
        this.setValueOnPreview(value, 'value_plot_interest_2');
      }
    },
    setValuePlot() {
      if (typeof this.$store.getters['poster/field']('value_plot') != undefined) {
        let value = this.$store.getters['poster/field']('value_plot');
        this.setValueOnPreview(value, 'value_plot');
      }
    },
    setValuePlotSeparated() {
      if (this.$store.getters['poster/field']('value_plot_separated')) {
        let value = this.$store.getters['poster/field']('value_plot_separated');
        this.setValueOnPreview(value, 'value_plot_separated');
      }
    },
    setValuePlotSeparated2() {
      if (this.$store.getters['poster/field']('value_plot_separated_2')) {
        let value = this.$store.getters['poster/field']('value_plot_separated_2');
        this.setValueOnPreview(value, 'value_plot_separated_2');
      }
    },
    setExclusiveValuePlot() {
      if (this.$store.getters['poster/field']('exclusive_value_plot')) {
        let value = this.$store.getters['poster/field']('exclusive_value_plot');
        this.setValueOnPreview(value, 'exclusive_value_plot');
      }
    },
    setExclusiveValuePlot2() {
      if (this.$store.getters['poster/field']('exclusive_value_plot_2')) {
        let value = this.$store.getters['poster/field']('exclusive_value_plot_2');
        this.setValueOnPreview(value, 'exclusive_value_plot_2');
      }
    },
    setValueRemaing() {
      if (typeof this.$store.getters['poster/field']('value_remaining') != undefined) {
        let value = this.$store.getters['poster/field']('value_remaining');
        this.setValueOnPreview(value, 'value_remaining');
      }
    },
    setValueRetail() {
      if (typeof this.$store.getters['poster/field']('value_retail') != undefined) {
        let value = this.$store.getters['poster/field']('value_retail');
        this.setValueOnPreview(value, 'value_retail');
      }
    },
    setValueWholeretail() {
      if (typeof this.$store.getters['poster/field']('value_wholeretail') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholeretail');
        this.setValueOnPreview(value, 'value_wholeretail');
      }
    },
    setValueWholeretail2() {
      if (typeof this.$store.getters['poster/field']('value_wholeretail_2') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholeretail_2');
        this.setValueOnPreview(value, 'value_wholeretail_2');
      }
    },
    setValueWholeretail3() {
      if (typeof this.$store.getters['poster/field']('value_wholeretail_3') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholeretail_3');
        this.setValueOnPreview(value, 'value_wholeretail_3');
      }
    },
    setValueWholeretail4() {
      if (typeof this.$store.getters['poster/field']('value_wholeretail_4') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholeretail_4');
        this.setValueOnPreview(value, 'value_wholeretail_4');
      }
    },
    setValueWholeretail5() {
      if (typeof this.$store.getters['poster/field']('value_wholeretail_5') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholeretail_5');
        this.setValueOnPreview(value, 'value_wholeretail_5');
      }
    },
    setProportionalValue() {
      if (typeof this.$store.getters['poster/field']('proportional_value') != undefined) {
        let value = this.$store.getters['poster/field']('proportional_value');
        this.setValueOnPreview(value, 'proportional_value');
      }

      if (typeof this.$store.getters['poster/field']('proportional_value') != undefined &&
          typeof this.$store.getters['poster/field']('unit_proportional') != undefined) {
        let proportional_value = this.$store.getters['poster/field']('proportional_value');
        let unit_proportional = this.$store.getters['poster/field']('unit_proportional');
        unit_proportional = unit_proportional ? unit_proportional : ' ';

        if (proportional_value && !proportional_value.match(/^[\d\s.,]+$/)) {
          return;
        }

        if (proportional_value) {
          let originalHtml = 'R$ 0,00 por Unidade de venda proporcional';
          this.preview('proportional_value_inline', 'text', originalHtml);

          let html = $('div[data-role=proportional_value_inline] .component-content span.text').html();
          if (html != undefined) {
            let newHtml = html.replace('Unidade de venda proporcional', unit_proportional);

            let numbers = newHtml.match(/(\d+[,.]\d{2})/g);
            if (numbers) {
              let text_parts = newHtml.split(' ');
              let occurrences = 0;
              text_parts = text_parts.map(function (text) {
                if (text.includes(numbers[0]) && occurrences === 0) {
                  text = text.replace(numbers[0], proportional_value);
                  occurrences = 1;
                }
                return text;
              });
              this.preview('proportional_value_inline', 'text', text_parts.join(' '));
            }
          }
        }
      }
    },
    setValueSum() {
      if (typeof this.$store.getters['poster/field']('value_sum') != undefined) {
        let value = this.$store.getters['poster/field']('value_sum');
        this.setValueOnPreview(value, 'value_sum');
      }
    },
    setValueTotalWholesale() {
      if (typeof this.$store.getters['poster/field']('value_total_wholesale') != undefined) {
        let value = this.$store.getters['poster/field']('value_total_wholesale');
        this.setValueOnPreview(value, 'value_total_wholesale');
      }
    },
    setValueWholesale() {
      if (typeof this.$store.getters['poster/field']('value_wholesale') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholesale');
        this.setValueOnPreview(value, 'value_wholesale');
      }
    },
    setValueWholesaleCard() {
      if (typeof this.$store.getters['poster/field']('value_wholesale_card') != undefined) {
        let value = this.$store.getters['poster/field']('value_wholesale_card');
        this.setValueOnPreview(value, 'value_wholesale_card');
      }
    },
    setValueCashTag(insert_value_cash_tag) {
      let valueCashTagByDataRole = document.querySelector('div[data-role="value_cash_tag"]');
      let valueCashTagByTitle = document.querySelector('[title="VAL_A_VISTA_ETIQUETA"]');
      let valueCashTag = !!valueCashTagByDataRole ? valueCashTagByDataRole : valueCashTagByTitle

      if (!!valueCashTag) {
        if (!!insert_value_cash_tag && typeof this.$store.getters['poster/field']('value_cash_tag') != undefined) {
          valueCashTag.classList.remove('d-none');
          this.hideOrShowFieldDivAliasByName('VAL_A_VISTA_ETIQUETA', false);

          let value = this.$store.getters['poster/field']('value_cash_tag');
          this.setValueOnPreview(value, 'value_cash_tag');
        } else {
          this.$store.commit('poster/SET_VALUE_CASH_TAG', undefined);
          valueCashTag.classList.add('d-none');
          this.hideOrShowFieldDivAliasByName('VAL_A_VISTA_ETIQUETA', true);
        }
      }
    },
    hideOrShowFieldDivAliasByName(field, shouldHide) {
      let aliasTags = document.getElementsByTagName('alias');
      for (let i = 0; i < aliasTags.length; i++) {
        if (aliasTags[i].getAttribute('title') === field) {
          let divToHide = aliasTags[i].closest('.component-content');

          if (divToHide) {
            if (shouldHide) {
              divToHide.classList.add('d-none');
            } else {
              divToHide.classList.remove('d-none');
            }
          }
        }
      }
    },
    setInsertValueCashTag() {
      if (typeof this.$store.getters['poster/field']('insert_value_cash_tag') != undefined) {
        this.$store.commit('poster/SET_VALUE_CASH_TAG', this.productSelected.price);
        this.setValueCashTag(this.$store.getters['poster/field']('insert_value_cash_tag'));
      }
    },
    setValidFrom() {
      if (typeof this.$store.getters['poster/field']('valid_from') != undefined) {
        let valid_from = dayjs(this.$store.getters['poster/field']('valid_from'));
        this.preview('valid_from', 'date', valid_from.format('DD/MM/YYYY'));
        this.previewMarked('valid_from', valid_from.format('DD/MM/YYYY'));
      }
      if (typeof this.$store.getters['poster/field']('valid_from') != undefined &&
          typeof this.$store.getters['poster/field']('valid_until') != undefined) {
        let valid_from = this.$store.getters['poster/field']('valid_from');
        if (valid_from) {
          valid_from = dayjs(this.$store.getters['poster/field']('valid_from'));
          let html = $('div[data-role=valid_date_inline] .component-content span.text').html();
          if (html != undefined) {
            let dates = html.match(/([0-9\/]{8,10})/g);
            let date_text = html.split(' ');
            let occurrences = 0;
            date_text = date_text.map(function (text) {
              if (text.includes(dates[0]) && occurrences === 0) {
                text = text.replace(dates[0], valid_from.format('DD/MM/YYYY'));
                occurrences = 1;
              }
              return text;
            });
            this.preview('valid_date_inline', 'text', date_text.join(' '));
          }
        }
      }
    },
    generateQrCode(url) {
      const qrcodeEncoder = new Encoder();
      qrcodeEncoder.write(url);
      qrcodeEncoder.make();
      return qrcodeEncoder.toDataURL(15, 20);
    },
    createImageCustomQrCode(url = undefined) {
      $('#custom_qr_code').removeClass('d-none').attr('src', this.generateQrCode(url));
    },
    createImageQrCode(url = undefined) {
      $('#qr_code').removeClass('d-none').attr('src', this.generateQrCode(url));
    },
    setImageCustomQrCode(isQrCode) {
      let qrcode = document.querySelector('div[data-role="custom_qr_code"]');
      if (!!qrcode) {
        if ((this.isMagazine || !!isQrCode) && this.custom_qr_code) {
          this.createImageCustomQrCode(this.custom_qr_code);
        } else {
          $('#custom_qr_code').addClass('d-none');
        }
      }
      this.poster = $('#preview').html();
    },
    setImageQrCode(isQrCode) {
      let qrcode = document.querySelector('div[data-role="qr_code"]');
      if (!!qrcode) {
        if (!!isQrCode) {
          this.createImageQrCode(this.qr_code);
        } else {
          $('#qr_code').addClass('d-none');
        }
      }
      this.poster = $('#preview').html();
    },
    createImageBarcode() {
      if (this.insert_barcode) {
        const barCode = $('#bar_code');
        if (barCode[0]) {
          barCode.css('width', '100%').css('height', '100%');
          barCode.removeClass('d-none').attr('src', '');

          let barcode = this.bar_code;
          if (!this.bar_code) {
            barcode = "0";
          }

          barcode = barcode.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          JsBarcode('#bar_code', barcode);
        }
      }
      this.poster = $('#preview').html();
    },
    setImageBarcode(isBarcode) {
      if (!!isBarcode) {
        this.createImageBarcode();
      } else {
        $('#bar_code').addClass('d-none');
      }
      this.poster = $('#preview').html();
    },
    setValidUntil() {
      if (typeof this.$store.getters['poster/field']('valid_until') != undefined) {
        let valid_until = dayjs(this.$store.getters['poster/field']('valid_until'));
        this.preview('valid_until', 'date', valid_until.format('DD/MM/YYYY'));
        this.previewMarked('valid_until', valid_until.format('DD/MM/YYYY'));
      }
      if (typeof this.$store.getters['poster/field']('valid_from') != undefined &&
          typeof this.$store.getters['poster/field']('valid_until') != undefined) {
        let valid_until = this.$store.getters['poster/field']('valid_until');
        if (valid_until) {
          valid_until = dayjs(this.$store.getters['poster/field']('valid_until'));
          let html = $('div[data-role=valid_date_inline] .component-content span.text').html();
          if (html != undefined) {
            let dates = html.match(/([0-9/]{10})/g);
            let date_text = $('div[data-role=valid_date_inline] .component-content span.text').html().split(' ');
            let occurrences = 0;
            date_text = date_text.map(function (text) {
              if (text.match(/([0-9/]{10})/g))
                occurrences++;
              if (dates[1] == text && occurrences > 1) {
                text = valid_until.format('DD/MM/YYYY');
              }
              return text;
            });
            this.preview('valid_date_inline', 'text', date_text.join(' '));
          }
        }
      }
    },
    setValidate() {
      if (typeof this.$store.getters['poster/field']('validate') != undefined) {
        let validate = dayjs(this.$store.getters['poster/field']('validate'));
        this.preview('validate', 'date', validate.format('DD/MM/YYYY'));
        this.previewMarked('validate', validate.format('DD/MM/YYYY'));
      }
    },
    setProductOlder() {
      if (typeof this.$store.getters['poster/field']('product_older') != undefined) {
        let product_older = this.$store.getters['poster/field']('product_older');
        this.preview('product_older', 'desciption', product_older);
        this.previewMarked('product_older', product_older);
      }
    },
    setParceled() {
      if (typeof this.$store.getters['poster/field']('parceled') != undefined) {
        let value = this.$store.getters['poster/field']('parceled');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('parceled', 'integer', value);
        this.previewInline('parceled_inline', 'value', value);
        this.previewMarked('parceled', value);
      }
    },
    setParceledInterest() {
      if (typeof this.$store.getters['poster/field']('parceled_interest') != undefined) {
        let value = this.$store.getters['poster/field']('parceled_interest');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('parceled_interest', 'integer', value);
        this.previewInline('parceled_interest_inline', 'value', value);
        this.previewMarked('parceled_interest', value);
      }
    },

    setParceledInterest2() {
      if (typeof this.$store.getters['poster/field']('parceled_interest_2') != undefined) {
        let value = this.$store.getters['poster/field']('parceled_interest_2');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('parceled_interest_2', 'integer', value);
        this.previewInline('parceled_interest_inline', 'value', value);
        this.previewMarked('parceled_interest_2', value);
      }
    },
    setMainDescription() {
      if (typeof this.$store.getters['poster/field']('main_description') != undefined) {
        let mainDescription = this.$store.getters['poster/field']('main_description');
        if (mainDescription)
          mainDescription = mainDescription.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('main_description', 'desciption', mainDescription);
        this.previewMarked('main_description', mainDescription);
      }
    },
    setFromWholesale() {
      if (typeof this.$store.getters['poster/field']('from_wholesale') != undefined) {
        let from_wholesale = this.$store.getters['poster/field']('from_wholesale');
        if (from_wholesale)
          from_wholesale = from_wholesale.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('from_wholesale', 'desciption', from_wholesale);
        this.previewMarked('from_wholesale', from_wholesale);
      }
    },
    setFromLarge() {
      if (typeof this.$store.getters['poster/field']('from_large') != undefined) {
        let from_large = this.$store.getters['poster/field']('from_large');
        if (from_large)
          from_large = from_large.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('from_large', 'desciption', from_large);
        this.previewMarked('from_large', from_large);
      }
    },
    setProportionalMeasure() {
      if (typeof this.$store.getters['poster/field']('proportional_measure') != undefined) {
        let proportional_measure = this.$store.getters['poster/field']('proportional_measure');
        this.preview('proportional_measure', 'desciption', proportional_measure);
        this.previewMarked('proportional_measure', proportional_measure);
      }

      if (typeof this.$store.getters['poster/field']('proportional_measure') != undefined &&
          typeof this.$store.getters['poster/field']('product_proportional_value') != undefined) {
        let proportional_measure = this.$store.getters['poster/field']('proportional_measure');
        if (!proportional_measure || proportional_measure.trim() === '') {
          proportional_measure = ' ';
        }

        let element = $('div[data-role=product_proportional_value_inline] .component-content span.text');
        let html = element.html();

        if (html != undefined) {
          if (html.includes('data-measure-marker')) {
            let markerMatch = html.match(/(<span[^>]*data-measure-marker[^>]*data-after="([^"]*)"[^>]*>.*?<\/span>)/i);
            if (markerMatch) {
              let marker = markerMatch[1];
              let afterText = markerMatch[2];
              let newHtml = html.replace(/(<span[^>]*data-measure-marker[^>]*>.*?<\/span>)[^<]*/, marker + proportional_measure + afterText);
              this.preview('product_proportional_value_inline', 'text', newHtml);
            } else {
              let match = html.match(/(<span[^>]*data-measure-marker[^>]*>.*?<\/span>)([^<]*)/i);
              if (match) {
                let marker = match[1];
                let afterText = match[2];
                let newMarker = marker.replace('<span', '<span data-after="' + afterText + '"');
                let newHtml = html.replace(/(<span[^>]*data-measure-marker[^>]*>.*?<\/span>)[^<]*/, newMarker + proportional_measure + afterText);
                this.preview('product_proportional_value_inline', 'text', newHtml);
              }
            }
          } else {
            let match = html.match(/(.*?)(Medida\s+Proporcional)(.*)/gi);
            if (match) {
              let fullMatch = match[0];
              let parts = fullMatch.match(/(.*?)(Medida\s+Proporcional)(.*)/i);
              if (parts) {
                let before = parts[1];
                let after = parts[3];
                let newHtml = before + '<span data-measure-marker data-after="' + after + '" style="display:none;">Medida Proporcional</span>' + proportional_measure + after;
                this.preview('product_proportional_value_inline', 'text', newHtml);
              }
            }
          }
        }
      }
    },
    setProportionalQuantity() {
      if (typeof this.$store.getters['poster/field']('proportional_quantity') != undefined) {
        this.preview('proportional_quantity', 'integer', this.$store.getters['poster/field']('proportional_quantity'));
        this.previewMarked('proportional_quantity', this.$store.getters['poster/field']('proportional_quantity'));
      }
    },
    setProductProportionalValue() {
      if (typeof this.$store.getters['poster/field']('product_proportional_value') != undefined) {
        let value = this.$store.getters['poster/field']('product_proportional_value');
        this.setValueOnPreview(value, 'product_proportional_value');
      }

      if (typeof this.$store.getters['poster/field']('product_proportional_value') != undefined &&
          typeof this.$store.getters['poster/field']('proportional_measure') != undefined) {
        let product_proportional_value = this.$store.getters['poster/field']('product_proportional_value');
        let proportional_measure = this.$store.getters['poster/field']('proportional_measure');

        if (product_proportional_value && !product_proportional_value.match(/^[\d\s.,]+$/)) {
          return;
        }

        if (product_proportional_value && proportional_measure) {
          let originalHtml = 'Preço por Medida Proporcional: 0,00';
          this.preview('product_proportional_value_inline', 'text', originalHtml);

          let html = $('div[data-role=product_proportional_value_inline] .component-content span.text').html();
          if (html != undefined) {
            let newHtml = html.replace('Medida Proporcional', proportional_measure);

            let numbers = newHtml.match(/([\d]+[.,][\d]+)/g);
            if (numbers) {
              let text_parts = newHtml.split(' ');
              let occurrences = 0;
              text_parts = text_parts.map(function (text) {
                if (text.includes(numbers[0]) && occurrences === 0) {
                  text = text.replace(numbers[0], product_proportional_value);
                  occurrences = 1;
                }
                return text;
              });
              this.preview('product_proportional_value_inline', 'text', text_parts.join(' '));
            }
          }
        }
      }
    },
    setMainDescription2() {
      if (typeof this.$store.getters['poster/field']('main_description2') != undefined) {
        let mainDescription2 = this.$store.getters['poster/field']('main_description2');
        if (mainDescription2)
          mainDescription2 = mainDescription2.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('main_description2', 'desciption', mainDescription2);
        this.previewMarked('main_description2', mainDescription2);
      }
    },
    setMainDescription3() {
      if (typeof this.$store.getters['poster/field']('main_description3') != undefined) {
        let mainDescription3 = this.$store.getters['poster/field']('main_description3');
        if (mainDescription3)
          mainDescription3 = mainDescription3.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('main_description3', 'desciption', mainDescription3);
        this.previewMarked('main_description3', mainDescription3);
      }
    },
    setMinorDescription() {
      if (typeof this.$store.getters['poster/field']('minor_description') != undefined) {
        this.preview('minor_description', 'desciption', this.$store.getters['poster/field']('minor_description'));
        this.previewMarked('minor_description', this.$store.getters['poster/field']('minor_description'));
      }
    },
    setMinorDescription2() {
      if (typeof this.$store.getters['poster/field']('minor_description2') != undefined) {
        this.preview('minor_description2', 'desciption', this.$store.getters['poster/field']('minor_description2'));
        this.previewMarked('minor_description2', this.$store.getters['poster/field']('minor_description2'));
      }
    },
    setMinorDescription3() {
      if (typeof this.$store.getters['poster/field']('minor_description3') != undefined) {
        this.preview('minor_description3', 'desciption', this.$store.getters['poster/field']('minor_description3'));
        this.previewMarked('minor_description3', this.$store.getters['poster/field']('minor_description3'));
      }
    },
    setSimpleDescription() {
      if (typeof this.$store.getters['poster/field']('simple_description') != undefined) {
        let simplesDescription = this.$store.getters['poster/field']('simple_description');
        if (simplesDescription)
          simplesDescription = simplesDescription.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('simple_description', 'desciption', simplesDescription);
        this.previewMarked('simple_description', simplesDescription);
      }
    },
    setSimpleDescription2() {
      if (typeof this.$store.getters['poster/field']('simple_description2') != undefined) {
        let simplesDescription = this.$store.getters['poster/field']('simple_description2');
        if (simplesDescription)
          simplesDescription = simplesDescription.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('simple_description2', 'desciption', simplesDescription);
        this.previewMarked('simple_description2', simplesDescription);
      }
    },
    setSimpleDescription3() {
      if (typeof this.$store.getters['poster/field']('simple_description3') != undefined) {
        let simplesDescription = this.$store.getters['poster/field']('simple_description3');
        if (simplesDescription)
          simplesDescription = simplesDescription.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('simple_description3', 'desciption', simplesDescription);
        this.previewMarked('simple_description3', simplesDescription);
      }
    },
    setSimpleDescription4() {
      if (typeof this.$store.getters['poster/field']('simple_description4') != undefined) {
        this.preview('simple_description4', 'desciption', this.$store.getters['poster/field']('simple_description4'));
        this.previewMarked('simple_description4', this.$store.getters['poster/field']('simple_description4'));
      }
    },
    setSimpleDescription5() {
      if (typeof this.$store.getters['poster/field']('simple_description5') != undefined) {
        this.preview('simple_description5', 'desciption', this.$store.getters['poster/field']('simple_description5'));
        this.previewMarked('simple_description5', this.$store.getters['poster/field']('simple_description5'));
      }
    },
    setReoperatedProduct() {
      if (typeof this.$store.getters['poster/field']('reoperated_product') != undefined) {
        this.preview('reoperated_product', 'desciption', this.$store.getters['poster/field']('reoperated_product'));
        this.previewMarked('reoperated_product', this.$store.getters['poster/field']('reoperated_product'));
      }
    },
    setProductDepth() {
      if (typeof this.$store.getters['poster/field']('product_depth') != undefined) {
        let product_depth = this.$store.getters['poster/field']('product_depth');
        this.preview('product_depth', 'desciption', product_depth);
        this.previewMarked('product_depth', product_depth);
      }
    },
    setProductOtherSizes() {
      if (typeof this.$store.getters['poster/field']('product_other_sizes') != undefined) {
        let product_other_sizes = this.$store.getters['poster/field']('product_other_sizes');
        if (product_other_sizes)
          product_other_sizes = product_other_sizes.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('product_other_sizes', 'desciption', product_other_sizes);
        this.previewMarked('product_other_sizes', product_other_sizes);
      }
    },
    setProductOtherColors() {
      if (typeof this.$store.getters['poster/field']('product_other_colors') != undefined) {
        let product_other_colors = this.$store.getters['poster/field']('product_other_colors');
        if (product_other_colors)
          product_other_colors = product_other_colors.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('product_other_colors', 'desciption', product_other_colors);
        this.previewMarked('product_other_colors', product_other_colors);
      }
    },
    setProductComments() {
      if (typeof this.$store.getters['poster/field']('product_comments') != undefined) {
        let product_comments = this.$store.getters['poster/field']('product_comments');
        this.preview('product_comments', 'desciption', product_comments);
        this.previewMarked('product_comments', product_comments);
      }
    },
    setProductEvaluation() {
      if (typeof this.$store.getters['poster/field']('product_evaluation') != undefined) {
        let product_evaluation = this.$store.getters['poster/field']('product_evaluation');
        this.preview('product_evaluation', 'desciption', product_evaluation);
        this.previewMarked('product_evaluation', product_evaluation);
      }
    },
    setProductMaterial() {
      if (typeof this.$store.getters['poster/field']('product_material') != undefined) {
        let product_material = this.$store.getters['poster/field']('product_material');
        this.preview('product_material', 'desciption', product_material);
        this.previewMarked('product_material', product_material);
      }
    },
    setProductHeight() {
      if (typeof this.$store.getters['poster/field']('product_height') != undefined) {
        let productHeight = this.$store.getters['poster/field']('product_height');
        this.preview('product_height', 'desciption', productHeight);
        this.previewMarked('product_height', productHeight);
      }
    },
    setProductWidth() {
      if (typeof this.$store.getters['poster/field']('product_width') != undefined) {
        let productWidth = this.$store.getters['poster/field']('product_width');
        this.preview('product_width', 'desciption', productWidth);
        this.previewMarked('product_width', productWidth);
      }
    },
    setBrand() {
      if (typeof this.$store.getters['poster/field']('brand') != undefined) {
        let brand = this.$store.getters['poster/field']('brand');
        this.preview('brand', 'desciption', brand);
        this.previewMarked('brand', brand);
      }
    },
    setRetailPackaging() {
      if (typeof this.$store.getters['poster/field']('retail_packaging') != undefined) {
        let retail_packaging = this.$store.getters['poster/field']('retail_packaging');
        this.preview('retail_packaging', 'desciption', retail_packaging);
        this.previewMarked('retail_packaging', retail_packaging);
      }
    },
    setWholesalePacking() {
      if (typeof this.$store.getters['poster/field']('wholesale_packing') != undefined) {
        let wholesale_packing = this.$store.getters['poster/field']('wholesale_packing');
        this.preview('wholesale_packing', 'desciption', wholesale_packing);
        this.previewMarked('wholesale_packing', wholesale_packing);
      }
    },
    setBigPacking() {
      if (typeof this.$store.getters['poster/field']('big_packing') != undefined) {
        let big_packing = this.$store.getters['poster/field']('big_packing');
        this.preview('big_packing', 'desciption', big_packing);
        this.previewMarked('big_packing', big_packing);
      }
    },
    setValidation() {
      if (typeof this.$store.getters['poster/field']('validation') != undefined) {
        let validation = this.$store.getters['poster/field']('validation');
        this.preview('validation', 'desciption', validation);
        this.previewMarked('validation', validation);
      }
    },
    setRetailTaxation() {
      if (typeof this.$store.getters['poster/field']('retail_taxation') != undefined) {
        let retail_taxation = this.$store.getters['poster/field']('retail_taxation');
        this.preview('retail_taxation', 'desciption', retail_taxation);
        this.previewMarked('retail_taxation', retail_taxation);
      }
    },
    setWholesaleTaxation() {
      if (typeof this.$store.getters['poster/field']('wholesale_taxation') != undefined) {
        let wholesale_taxation = this.$store.getters['poster/field']('wholesale_taxation');
        this.preview('wholesale_taxation', 'desciption', wholesale_taxation);
        this.previewMarked('wholesale_taxation', wholesale_taxation);
      }
    },
    setBigTaxation() {
      if (typeof this.$store.getters['poster/field']('big_taxation') != undefined) {
        let big_taxation = this.$store.getters['poster/field']('big_taxation');
        this.preview('big_taxation', 'desciption', big_taxation);
        this.previewMarked('big_taxation', big_taxation);
      }
    },
    setLightTaxation() {
      if (typeof this.$store.getters['poster/field']('light_taxation') != undefined) {
        let light_taxation = this.$store.getters['poster/field']('light_taxation');
        this.preview('light_taxation', 'desciption', light_taxation);
        this.previewMarked('light_taxation', light_taxation);
      }
    },
    setRetailMedia() {
      if (typeof this.$store.getters['poster/field']('retail_media') != undefined) {
        let retail_media = this.$store.getters['poster/field']('retail_media');
        this.preview('retail_media', 'desciption', retail_media);
        this.previewMarked('retail_media', retail_media);
      }
    },
    setWholesaleMedia() {
      if (typeof this.$store.getters['poster/field']('wholesale_media') != undefined) {
        let wholesale_media = this.$store.getters['poster/field']('wholesale_media');
        this.preview('wholesale_media', 'desciption', wholesale_media);
        this.previewMarked('wholesale_media', wholesale_media);
      }
    },
    setBigMedia() {
      if (typeof this.$store.getters['poster/field']('big_media') != undefined) {
        let big_media = this.$store.getters['poster/field']('big_media');
        this.preview('big_media', 'desciption', big_media);
        this.previewMarked('big_media', big_media);
      }
    },
    setLightMedia() {
      if (typeof this.$store.getters['poster/field']('light_media') != undefined) {
        let light_media = this.$store.getters['poster/field']('light_media');
        this.preview('light_media', 'desciption', light_media);
        this.previewMarked('light_media', light_media);
      }
    },
    setBigPrice() {
      let value = this.$store.getters['poster/field']('big_price');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'big_price');
      }
    },
    setLightPrice() {
      let value = this.$store.getters['poster/field']('light_price');
      if (typeof value != undefined) {
        this.setValueOnPreview(value, 'light_price');
      }
    },
    setLightQuantity() {
      if (typeof this.$store.getters['poster/field']('light_quantity') != undefined) {
        let light_quantity = this.$store.getters['poster/field']('light_quantity');
        this.preview('light_quantity', 'desciption', light_quantity);
        this.previewMarked('light_quantity', light_quantity);
      }
    },
    setFreeText() {
      if (typeof this.$store.getters['poster/field']('free_text') != undefined) {
        let freeText = this.$store.getters['poster/field']('free_text');
        if (freeText)
          freeText = freeText.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('free_text', 'desciption', freeText);
        this.previewMarked('free_text', freeText);
      }
    },
    setFreeText2() {
      if (typeof this.$store.getters['poster/field']('free_text2') != undefined) {
        let freeText = this.$store.getters['poster/field']('free_text2');
        if (freeText)
          freeText = freeText.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('free_text2', 'desciption', freeText);
        this.previewMarked('free_text2', freeText);
      }
    },
    setFreeText3() {
      if (typeof this.$store.getters['poster/field']('free_text3') != undefined) {
        let freeText = this.$store.getters['poster/field']('free_text3');
        if (freeText)
          freeText = freeText.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('free_text3', 'desciption', freeText);
        this.previewMarked('free_text3', freeText);
      }
    },
    setExclusiveParcel() {
      if (typeof this.$store.getters['poster/field']('exclusive_parcel') != undefined) {
        let value = this.$store.getters['poster/field']('exclusive_parcel');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('exclusive_parcel', 'integer', value);
        this.previewMarked('exclusive_parcel', value);
        this.previewInline('exclusive_parcel', 'value', value);
      }
    },
    setExclusiveParcel2() {
      if (typeof this.$store.getters['poster/field']('exclusive_parcel_2') != undefined) {
        let value = this.$store.getters['poster/field']('exclusive_parcel_2');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('exclusive_parcel_2', 'integer', value);
        this.previewMarked('exclusive_parcel_2', value);
        this.previewInline('exclusive_parcel_2', 'value', value);
      }
    },
    setParcel() {
      if (typeof this.$store.getters['poster/field']('parcel') != undefined) {
        let value = this.$store.getters['poster/field']('parcel');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('parceled', 'integer', value);
        this.previewMarked('parceled', value);
        this.previewInline('parceled_inline', 'value', value);
      }
    },
    setParcelSeparated2() {
      if (typeof this.$store.getters['poster/field']('parcel_separated_2') != undefined) {
        let value = this.$store.getters['poster/field']('parcel_separated_2');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('parcel_separated_2', 'integer', value);
        this.previewMarked('parcel_separated_2', value);
      }
    },
    setParcelPaid() {
      if (typeof this.$store.getters['poster/field']('parcel_paid') != undefined) {
        let value = this.$store.getters['poster/field']('parcel_paid');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('parcel_paid', 'integer', value);
        this.previewMarked('parcel_paid', value);
      }
    },
    setPaymentTypeText() {
      if (typeof this.$store.getters['poster/field']('payment_type') != undefined) {
        this.preview('payment_type', 'text', this.$store.getters['poster/field']('payment_type'));
        this.previewMarked('payment_type', this.$store.getters['poster/field']('payment_type'));
      }
    },
    setPaymentType() {
      if (typeof this.$store.getters['poster/field']('condition') != undefined) {
        this.preview('payment_type', 'text', this.$store.getters['poster/field']('condition'));
        this.previewMarked('payment_type', this.$store.getters['poster/field']('condition'));
      }
    },
    setProductCode() {
      if (typeof this.$store.getters['poster/field']('product_code') != undefined) {
        this.preview('product_code', 'code', this.$store.getters['poster/field']('product_code'));
        this.previewMarked('product_code', this.$store.getters['poster/field']('product_code'));
      }
    },
    setPromotionDescription() {
      if (typeof this.$store.getters['poster/field']('promotion_description') != undefined) {
        this.preview('promotion_description', 'description',
            this.$store.getters['poster/field']('promotion_description'));
        this.previewMarked('promotion_description', this.$store.getters['poster/field']('promotion_description'));
      }
    },
    setPromotionMainDescription() {
      if (typeof this.$store.getters['poster/field']('promotion_main_description') != undefined) {
        this.preview('promotion_main_description', 'main_description',
            this.$store.getters['poster/field']('promotion_main_description'));
        this.previewMarked('promotion_main_description',
            this.$store.getters['poster/field']('promotion_main_description'));
      }
    },
    setPromotionMinorDescription() {
      if (typeof this.$store.getters['poster/field']('promotion_minor_description') != undefined) {
        this.preview('promotion_minor_description', 'minor_description',
            this.$store.getters['poster/field']('promotion_minor_description'));
        this.previewMarked('promotion_minor_description',
            this.$store.getters['poster/field']('promotion_minor_description'));
      }
    },
    setPromotionProduct() {
      if (typeof this.$store.getters['poster/field']('promotion_product') != undefined) {
        this.preview('promotion_product', 'product', this.$store.getters['poster/field']('promotion_product'));
        this.previewMarked('promotion_product', this.$store.getters['poster/field']('promotion_product'));
      }
    },
    setPromotionUnit() {
      if (typeof this.$store.getters['poster/field']('promotion_unit') != undefined) {
        this.preview('promotion_unit', 'unit', this.$store.getters['poster/field']('promotion_unit'));
        this.previewMarked('promotion_unit', this.$store.getters['poster/field']('promotion_unit'));
      }
    },
    setPromotionUnit2() {
      if (typeof this.$store.getters['poster/field']('promotion_unit2') != undefined) {
        this.preview('promotion_unit2', 'unit', this.$store.getters['poster/field']('promotion_unit2'));
        this.previewMarked('promotion_unit2', this.$store.getters['poster/field']('promotion_unit2'));
      }
    },
    setPromotionalProductValue() {
      if (typeof this.$store.getters['poster/field']('promotional_product_value') != undefined) {
        let value = this.$store.getters['poster/field']('promotional_product_value');
        this.setValueOnPreview(value, 'promotional_product_value');
      }
    },
    setQuantity() {
      if (typeof this.$store.getters['poster/field']('quantity') != undefined) {
        this.preview('quantity', 'integer', this.$store.getters['poster/field']('quantity'));
        this.previewMarked('quantity', this.$store.getters['poster/field']('quantity'));
      }
    },
    setQuantityFractional() {
      if (typeof this.$store.getters['poster/field']('quantity_fractional') != undefined) {
        this.preview('quantity_fractional', 'integer', this.$store.getters['poster/field']('quantity_fractional'));
        this.previewMarked('quantity_fractional', this.$store.getters['poster/field']('quantity_fractional'));
      }
    },
    setQuantity2() {
      if (typeof this.$store.getters['poster/field']('quantity2') != undefined) {
        this.preview('quantity2', 'integer', this.$store.getters['poster/field']('quantity2'));
        this.previewMarked('quantity2', this.$store.getters['poster/field']('quantity2'));
      }
    },
    setQuantity3() {
      if (typeof this.$store.getters['poster/field']('quantity3') != undefined) {
        this.preview('quantity3', 'integer', this.$store.getters['poster/field']('quantity3'));
        this.previewMarked('quantity3', this.$store.getters['poster/field']('quantity3'));
      }
    },
    setQuantity4() {
      if (typeof this.$store.getters['poster/field']('quantity4') != undefined) {
        this.preview('quantity4', 'integer', this.$store.getters['poster/field']('quantity4'));
        this.previewMarked('quantity4', this.$store.getters['poster/field']('quantity4'));
      }
    },
    setQuantity5() {
      if (typeof this.$store.getters['poster/field']('quantity5') != undefined) {
        this.preview('quantity5', 'integer', this.$store.getters['poster/field']('quantity5'));
        this.previewMarked('quantity5', this.$store.getters['poster/field']('quantity5'));
      }
    },
    setRatesInfo() {
      if (typeof this.$store.getters['poster/field']('rates_info') != undefined) {
        this.preview('rates_info', 'text', this.$store.getters['poster/field']('rates_info'));
        this.previewMarked('rates_info', this.$store.getters['poster/field']('rates_info'));
      }
    },
    setSalesUnitWholeSale() {
      if (typeof this.$store.getters['poster/field']('sales_unit_wholesale') != undefined) {
        this.preview('sales_unit_wholesale', 'unit', this.$store.getters['poster/field']('sales_unit_wholesale'));
        this.previewMarked('sales_unit_wholesale', this.$store.getters['poster/field']('sales_unit_wholesale'));
      }
    },
    setDepartment() {
      if (typeof this.$store.getters['poster/field']('departament') != undefined) {
        this.preview('departament', 'departament', this.$store.getters['poster/field']('departament'));
        this.previewMarked('departament', this.$store.getters['poster/field']('departament'));
      }
    },
    setSalesUnit() {
      if (typeof this.$store.getters['poster/field']('sales_unit') != undefined) {
        this.preview('sales_unit', 'unit', this.$store.getters['poster/field']('sales_unit'));
        this.previewMarked('sales_unit', this.$store.getters['poster/field']('sales_unit'));
      }
    },
    setSalesUnit2() {
      if (typeof this.$store.getters['poster/field']('sales_unit2') != undefined) {
        this.preview('sales_unit2', 'unit', this.$store.getters['poster/field']('sales_unit2'));
        this.previewMarked('sales_unit2', this.$store.getters['poster/field']('sales_unit2'));
      }
    },
    setSalesUnit3() {
      if (typeof this.$store.getters['poster/field']('sales_unit3') != undefined) {
        this.preview('sales_unit3', 'unit', this.$store.getters['poster/field']('sales_unit3'));
        this.previewMarked('sales_unit3', this.$store.getters['poster/field']('sales_unit3'));
      }
    },
    setSpare() {
      if (typeof this.$store.getters['poster/field']('spare') != undefined) {
        let value = this.$store.getters['poster/field']('spare');
        this.setValueOnPreview(value, 'spare');
      }
    },
    setSparedPercent() {
      if (typeof this.$store.getters['poster/field']('spared_percent') != undefined) {
        let value = this.$store.getters['poster/field']('spared_percent');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('spared_percent', 'integer', value);
        this.previewMarked('spared_percent', value);
      }
    },
    setTotalTerm() {
      if (typeof this.$store.getters['poster/field']('total_term') != undefined) {
        let value = this.$store.getters['poster/field']('total_term');
        this.setValueOnPreview(value, 'total_term');
      }
    },
    setTotalTerm2() {
      if (typeof this.$store.getters['poster/field']('total_term_2') != undefined) {
        let value = this.$store.getters['poster/field']('total_term_2');
        this.setValueOnPreview(value, 'total_term_2');
      }
    },
    setPercentageApp() {
      if (typeof this.$store.getters['poster/field']('percentage_app') != undefined) {
        let value = this.$store.getters['poster/field']('percentage_app');
        value = /,00$/.test(value) ? value.replace(',00', '') : value;
        this.preview('percentage_app', 'integer', value);
        this.previewMarked('percentage_app', value);
      }
    },
    setPriceApp() {
      if (this.$store.getters['poster/field']('price_app')) {
        let value = this.$store.getters['poster/field']('price_app');
        this.setValueOnPreview(value, 'price_app');
      }
    },
    setLimitApp() {
      if (typeof this.$store.getters['poster/field']('limit_app') != undefined) {
        let value = this.$store.getters['poster/field']('limit_app');
        if (value)
          value = value.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('limit_app', 'text', value);
        this.previewMarked('limit_app', value);
      }
    },
    setPercentageCard() {
      if (typeof this.$store.getters['poster/field']('percentage_card') != undefined) {
        let value = this.$store.getters['poster/field']('percentage_card');
        if (value)
          value = value.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('percentage_card', 'text', value);
        this.previewMarked('percentage_card', value);
      }
    },
    setPriceCard() {
      if (this.$store.getters['poster/field']('price_card')) {
        let value = this.$store.getters['poster/field']('price_card');
        this.setValueOnPreview(value, 'price_card');
      }
    },
    setLimitCard() {
      if (typeof this.$store.getters['poster/field']('limit_card') != undefined) {
        let value = this.$store.getters['poster/field']('limit_card');
        if (value)
          value = value.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('limit_card', 'text', value);
        this.previewMarked('limit_card', value);
      }
    },
    setParcelNumberCard() {
      if (typeof this.$store.getters['poster/field']('parcel_number_card') != undefined) {
        this.preview('parcel_number_card', 'integer', this.$store.getters['poster/field']('parcel_number_card'));
        this.previewMarked('parcel_number_card', this.$store.getters['poster/field']('parcel_number_card'));
      }
    },
    setParcelPriceCard() {
      if (this.$store.getters['poster/field']('parcel_price_card')) {
        let value = this.$store.getters['poster/field']('parcel_price_card');
        this.setValueOnPreview(value, 'parcel_price_card');
      }
    },
    setMinimumApp() {
      if (typeof this.$store.getters['poster/field']('minimum_app') != undefined) {
        let value = this.$store.getters['poster/field']('minimum_app');
        if (value)
          value = value.replace(/[\n|\n\r]/g, '<br \>');
        this.preview('minimum_app', 'text', value);
        this.previewMarked('minimum_app', value);
      }
    },
    setValueOnPreview(value, data_role) {
      if (value) {
        let values = value.split(',');
        this.preview(data_role, 'integer', values[0]);
        this.preview(data_role, 'decimal', ',' + values[1]);
        this.previewMarked(data_role, value);
        this.previewInline(data_role + '_inline', 'value', value);
      }
    },
    loadTemplateContentInStore() {
      this.$store.commit('selector/SET_CONTENT', document.querySelector('#preview').innerHTML);
    },
    isNotUndefined(value) {
      return (typeof value != 'undefined' || value != null);
    },
    changeScale(element, scale) {
      $(element).css('transform', 'scale(' + scale + ')').css('-webkit-transform', 'scale(' + scale + ')').css('-ms-transform', 'scale(' + scale + ')');
    },
    preview(data_role, classType, value) {
      if (this.userPreferences.indexOf('toUpperCase') !== -1 && data_role !== 'legal_informations') {
        if (value && typeof value == 'string')
          value = value.toUpperCase();
      }
      $('div[data-role=' + data_role + '] .component-content span.' + classType).html(value);
      this.resize(data_role);
      this.previewMarked(data_role, value);
      this.poster = $('#preview').html();
    },
    previewMarked(data_role, value) {
      if (this.aliases[data_role] && this.isNotUndefined(this.aliases[data_role])) {
        if (this.userPreferences.indexOf('toUpperCase') !== -1 && data_role !== 'legal_informations' && value) {
          if (value && typeof value == 'string')
            value = value.toUpperCase();
        }
        this.aliases[data_role].forEach((alias) => {
          $('alias[value=' + alias + ']').text(value);
        });
        this.resize('marked-text-component');
      }
    },
    previewInline(data_role, classType, value) {
      if (value) {
        this.hideDate();
        this.hideProportionalValueInline();
        this.hideProductProportionalValueInline();
        this.hideProductDate();
        this.hideProductOlder();
        const element = $('div[data-role=' + data_role + '] .component-content span.' + classType);
        let text = $(element).html();
        if (typeof text != 'undefined') {
          $(element).parent().css('whiteSpace', 'nowrap');
          let numbers = text.match(/[0-9\.]*[0-9]+,*[0-9]{0,2}/g);
          if (numbers && numbers.length > 0) {
            text = text.replace(numbers[0], value);
          } else {
            text = text.replace(/true/g, value);
          }
          $(element).html(text);
          this.resize(data_role);
          this.poster = $('#preview').html();
        }
      }
    },
    resize(data_role) {
      let elements = document.querySelectorAll('div[data-role=' + data_role + '] .component-content');
      _.each(elements, (element) => {
        let parent = element.parentNode;
        let fontSize = parseInt(element.style.fontSize.replace('px', ''));
        if (!element.hasAttribute('data-fontSize')) {
          element.setAttribute('data-fontSize', fontSize);
        } else {
          fontSize = parseInt(element.getAttribute('data-fontSize'));
        }
        const customUserFontSize = _.get(this.template, 'fonts_size.data', []).find((field) => {
          return field.position == data_role;
        });
        if (customUserFontSize) {
          element.setAttribute('data-fontSize', customUserFontSize.size);
        }
        element.style.fontSize = element.getAttribute('data-fontSize') + 'px';

        let timeout = (this.justUpdateContent) ? 3000 : 0;
        setTimeout(() => {
          if (data_role.includes('description') || /^free_text\d*$/.test(data_role) || data_role.includes('brand')) {
            while (element.scrollHeight >= parent.offsetHeight) {
              fontSize--;
              element.style.fontSize = fontSize + 'px';
            }
          }

          while (element.scrollWidth > parent.offsetWidth) {
            fontSize--;
            element.style.fontSize = fontSize + 'px';
          }
        }, timeout);
      })
    },
    loadImages() {
      let images = $('[id^=image-]');
      let templateImages = [];
      images.each((index, image) => {
        let imageUrl = `/ajax/online/template/${this.template.id}/images/`;
        let hasImage = $(image).attr('src');
        let id = $(image).attr('id');
        let templateImage = this.template.images_template.find((templateImage) => {
          return templateImage.index == id;
        });
        if (!!templateImage && !hasImage) {
          imageUrl += templateImage.index;
          $(image).attr('src', imageUrl);
          id = templateImage.index;
        }
        const parentDiv = $(image).closest('[data-role^=image-]');
        if (!templateImage) {
          templateImages.push({
            index: id,
            preview: imageUrl,
            height: parentDiv.height(),
            width: parentDiv.width(),
          });
        }
      });
      this.templateImages = templateImages;
      this.poster = $('#preview').html();
    },
    loadTemplateColors() {
      SelectorService.fetchTemplateColors(this.template.id).then((response) => {
        this.templateColors = response.data;
      });
    },
    loadFontsSize() {
      if (_.get(this.template, 'fonts_size.data')) {
        this.template.fonts_size.data.map((field) => {
          $(`[data-role="${field.position}"] > div`).css('font-size', `${field.size}px`);
        })
        this.poster = $('#preview').html();
      }
    },
    setImageFromApi(image) {
      $('[id^=image-]').attr('src', image);
    },
  },
};
</script>

<style scoped>
.btn-link {
  color: #363a42;
}

.btn-link:hover {
  color: #4e91ff;
}

.affix-top {
  position: fixed;
  top: 100px;
  bottom: 0;
  right: 0;
  width: 38%;
  height: 100%;
}

@media screen and (max-width: 992px) {
  .affix-top {
    position: relative;
    width: 100%;
    top: 0;
  }
}

@media screen and (max-width: 500px) {
  .panel-full-alt4:not(.affix-preview-mobile) {
    z-index: -1;
    opacity: 0;
    -moz-transition: opacity 0.4s ease-in-out;
    -o-transition: opacity 0.4s ease-in-out;
    -webkit-transition: opacity 0.4s ease-in-out;
    transition: opacity 0.4s ease-in-out;
  }

  .affix-preview-mobile.panel-full-alt4 {
    position: fixed;
    width: 97%;
    bottom: 2.5em;
    height: 80%;
    opacity: 1;
    -moz-transition: opacity 0.4s ease-in-out;
    -o-transition: opacity 0.4s ease-in-out;
    -webkit-transition: opacity 0.4s ease-in-out;
    transition: opacity 0.4s ease-in-out;
  }

  .title {
    font-size: 13px !important;
    margin-top: 0.5em !important;
  }
}

.panel-body {
  padding: 10px 15px 10px;
  overflow: auto;
  height: 90%;
}

.poster-preview {
  transform-origin: top left;
  display: block;
  margin: 0 auto;
  position: relative;
}

.panel-full-alt4 .panel-heading {
  background-color: #354558;
  width: 100%;
  margin: 0;
}

.panel-full-alt4 {
  height: 90%;
  background-color: #e0e0e0;
  color: #fff;
}

#template-instructions {
  padding: 0 20px 10px;
}

.title {
  font-size: 15px;
  font-weight: 300;
  display: block;
  margin-top: 2px;
}

.toggle-preview-button {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  position: absolute !important;
}

.toggle-preview-button:not(:hover) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #ffffff !important;
}

.btn-group-fab {
  width: 40% !important;
  position: fixed !important;
  height: auto;
  right: -25%;
  bottom: 80%;
  z-index: 2
}

.preview-zoom {
  padding: 7px !important;
}

.panel-heading {
  height: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.btn-reset {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Preview.vue